import React, { useEffect, useState, useRef, Fragment } from "react";
import usePermission from "../../config/permissions";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { toast, ToastContainer } from "react-toastify";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

import { formatDate, formattedDateLong } from "../Date";
import { AddContractor, AddProjectDetails, DocumentModel } from "./ProjectDetailsCrudButtons";

import { useLocation, useNavigate } from "react-router-dom";
import { ProjectProgressBar } from "./SiteProjectManagementComponents";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { formatCurrencyIndian, formatRoundoff, formatRoundoffCrores, getProgressColor, handleErrorToast, Lock, sortProjects } from "../CustomFunctions";
import { CircularGrid, DeleteDustbin, SearchBig, SearchSmall, Sort } from "../AllSvg";
import { Modal } from "react-bootstrap";
import { SubCompany, SubCompanyModern } from "../FilterDropdown";
import { DownloadProjectAllDetails, UploadSiteProject } from "./BulkModals";
import { Progressreport } from "../Wfm/DetailPage";
import { EOTDetails } from "../Wfm/DetailPage";
import { COSDetails } from "../Wfm/DetailPage";
import { MilestoneDetails } from "../Wfm/DetailPage";
import { BillingDetailsProgress } from "../Wfm/DetailPage";
import { BGDetails } from "../Wfm/DetailPage";
import { InsuranceDetails } from "../Wfm/DetailPage";
import Select from "react-select";
import { DownloadSiteProject } from "../SiteManagement/BulkModals"
import { Projects } from "../FilterDropdown";
import StatusBar from "../StatusBar/StatusBar";
import './NewCSS.css'
import './css/filtercontainer.css'
import {
  Trash2, LayoutGrid, TrendingUp,
  ChevronDown, ChevronUp,
  Activity, Briefcase, Target, AlertCircle, CheckCircle,
  XCircle, Download, Share2, MoreVertical, BarChart3,
  Users, FolderOpen, Award, Zap, Shield, Bell, Calendar,
  Search, SortAsc, SortDesc, Building2, Clock, Columns, IndianRupee, FileText, Plus, SortAscIcon,
  Eye, Filter,
  Upload,
  Grid3x3, List, X, RefreshCw,

  MapPin,
  Sparkles,
  Sliders,
  BadgeIndianRupee,
  Construction,
  SortDescIcon,
  Check,
  ArrowUpAZ,
  ArrowDownAZ,
  ArrowUp,
  ArrowDown,
  Minus,
  BarChart,
  Workflow,
  Timer,
  CalendarCheck,
  Mail,
  MessageCircle,
  ShieldCheck,
  PencilRuler
} from "lucide-react";
import { ProgressBarGraph } from "./Progress";
import LetterButton from "./LetterModuleContractor/LetterButton";
import { AddProlongation } from "./Prolongation_Deviation/ProlongationCRUD";
import ProlongationButton from "./Prolongation_Deviation/ProlongationButton";




const DeleteProject = ({ i, fetchContractorProjects }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.delete(`${BASE_URL}/siteproject/project/${i.id}/`);

      if (res.status === 200) {
        await fetchContractorProjects();
        handleClose();
        toast.dismiss(loadingToastId);
        toast.success("Data deleted successfully.");

      } else {
        toast.dismiss(loadingToastId);
        toast.error("Failed to delete data!");
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err)
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button title="Delete Project" className="model-delete-button" onClick={handleShow}>
        <DeleteDustbin />
        {/* Delete */}
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Delete Project {i.project_short_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete Project {i.project_short_name}
            <div className="button-models">
              <button className="model-button font-weight500" onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button font-weight500  model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const SiteProjectTable = ({ toggleProject, setToggleProject }) => {
  const [projectList, setProjectList] = useState([]);
  // const [toggleProject, setToggleProject] = useState("")
  const siteSubcompany = sessionStorage.getItem("sitemanagement_project_sub_company")
  const [viewMode, setViewMode] = useState('table');
  const [toggleCompany, setToggleCompany] = useState(siteSubcompany || "null");
  const [selectedName, setSelectedName] = useState("null");
  const [sorting, setSorting] = useState("asc_pr");
  const role = sessionStorage.getItem('sitemanagement_role');
  const [buffering, setBuffering] = useState(false);
  const [filteredProject, setFilteredProject] = useState([]);


  const getProjects = async () => {
    setBuffering(true);
    setFilteredProject([]); // Clear filtered data before fetching new data
    // setProjectsList([]);
    const role = sessionStorage.getItem("sitemanagement_role");
    const empId = sessionStorage.getItem("sitemanagement_emp_id");

    let endpoint = "";

    if (role === "Admin" || role === "Hr") {
      endpoint = `${BASE_URL}/siteproject/projectdashboard/contractor/${selectedName}/${toggleCompany || "null"}/null/`;
    } else if (role === "AuthorityEngineer") {
      endpoint = `${BASE_URL}/siteproject/projectdashboardauth/contractor/${empId}/${toggleCompany || "null"}/null/`;
    } else if (role === "DataEntryOperator") {
      endpoint = `${BASE_URL}/siteproject/projectdashboardcomp/contractor/${empId}/null/`;
    } else {
      endpoint = `${BASE_URL}/siteproject/projectdashboard/contractor/${selectedName}/${toggleCompany || "null"}/null/`;
    }


    try {
      const response = await axios.get(endpoint);
      let filteredProjects = response.data;
      switch (sorting) {
        case "asc_pr":
          filteredProjects = sortProjects(filteredProjects, "site_prcode");
          break;
        case "desc_pr":
          filteredProjects = sortProjects(filteredProjects, "site_prcode").reverse();
          break;
        case "asc_short_name":
          filteredProjects = filteredProjects.sort((a, b) =>
            a.project_short_name.localeCompare(b.project_short_name)
          );
          break;
        case "desc_short_name":
          filteredProjects = filteredProjects.sort((a, b) =>
            b.project_short_name.localeCompare(a.project_short_name)
          );
          break;
        default:
          break;
      }
      // setProjectsList(filteredProjects);
      setFilteredProject(filteredProjects);

    } catch (error) {
      console.error('Error fetching contractor projects:', error);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getProjects();
  }, [toggleCompany, selectedName, sorting]);


  console.log("projectList,", projectList)


  const [projectListfilter, setProjectListfilter] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);



  // Event handlers

  const [isOpen, setIsOpen] = useState(false);
  const [selectedCC, setSelectedCC] = useState('contractor');
  const dropdownRef = useRef(null);

  const ccOptions = [
    { value: 'contractor', label: '🏗️ Contractor View' },
    { value: 'consultant', label: '📋 Consultant View' }
  ];

  const handleCCChange = (value) => {
    setSelectedCC(value);

  };

  const handleCCSelect = (value) => {
    handleCCChange(value);
    setIsOpen(false);
  };


  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  const [isSortOpen, setIsSortOpen] = useState(false);
  const sortDropdownRef = useRef(null);

  const handleSortChange = (value) => {
    setSorting(value);

  };

  const sortOptions = [
    { value: 'asc_pr', label: 'Asc. Pr Code', icon: ArrowUp, iconSize: 14 },
    { value: 'desc_pr', label: 'Desc. Pr Code', icon: ArrowDown, iconSize: 14 },
    { value: 'asc_short_name', label: 'Asc. Project Name', icon: ArrowUpAZ, iconSize: 14 },
    { value: 'desc_short_name', label: 'Desc. Project Name', icon: ArrowDownAZ, iconSize: 14 }
  ];


  const handleSortSelect = (value) => {
    handleSortChange(value);
    setIsSortOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sortDropdownRef.current && !sortDropdownRef.current.contains(event.target)) {
        setIsSortOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const [isFiltersVisible, setIsFiltersVisible] = useState(true); // or false if you want them collapsed by default

  // Add this toggle function
  const toggleFilters = () => {
    setIsFiltersVisible(!isFiltersVisible);
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Dashboardnavbar name="All Projects" url="Projects" />

      <div className="content-tabs" >
        <div className={!isFiltersVisible && "containers"} >


          <div className="attendance-subcont" style={{ display: !isFiltersVisible && "none", padding: "0px", background: "transparent", }}>
            {/* Add the header with min/max button */}


            {/* Conditionally render the filter content */}
            {isFiltersVisible && (
              <>
                <div className="filters-content">
                  <div className="field-cont" style={{ width: "100%", gap: "10px" }}>
                    {
                      siteSubcompany !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" &&
                      <SubCompanyModern toggleCompany={toggleCompany} setToggleCompany={setToggleCompany} cssType="modern" />
                    }

                    <div className="field-cont-div" style={{ width: "20%" }} ref={sortDropdownRef}>
                      <div className="subcompany-modern-wrappers" style={{ flex: 1 }}>
                        <div className="subcompany-selectorssss" onClick={() => setIsSortOpen(!isSortOpen)}>
                          <div className="subcompany-selectorssss-content">
                            {(() => {
                              const selectedOption = sortOptions.find(opt => opt.value === sorting);
                              const IconComponent = selectedOption?.icon;
                              return (
                                <>
                                  {typeof selectedOption?.icon === 'string' ? (
                                    <span style={{ marginRight: '8px' }}>{selectedOption.icon}</span>
                                  ) : (
                                    IconComponent && <IconComponent size={14} style={{ marginRight: '8px' }} />
                                  )}
                                  <span>{selectedOption?.label || 'Sort Filter'}</span>
                                </>
                              );
                            })()}
                          </div>
                          <div className="selector-actionsss">
                            <ChevronDown size={16} className={`dropdown-arrow ${isSortOpen ? 'rotate' : ''}`} />
                          </div>
                        </div>

                        {isSortOpen && (
                          <div className="subcompany-dropdownss">
                            <div className="dropdown-listsss">
                              {sortOptions.map((option) => {
                                const IconComponent = option.icon;
                                return (
                                  <div
                                    key={option.value}
                                    className={`dropdown-itemss ${sorting === option.value ? 'selected' : ''}`}
                                    onClick={() => handleSortSelect(option.value)}
                                  >
                                    {typeof option.icon === 'string' ? (
                                      <span style={{ marginRight: '8px' }}>{option.icon}</span>
                                    ) : (
                                      <IconComponent size={option.iconSize || 14} style={{ marginRight: '8px' }} />
                                    )}
                                    <span style={{ flex: 1 }}>{option.label}</span>
                                    {sorting === option.value && (
                                      <Check size={14} className="check-iconn" />
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="subcompany-modern-containers" style={{ width: "20%" }} ref={dropdownRef}>
                      <div className="subcompany-modern-wrappers">
                        <div className="subcompany-selectorssss" onClick={() => setIsOpen(!isOpen)}>
                          <div className="subcompany-selectorssss-content">
                            {ccOptions.find(opt => opt.value === selectedCC)?.label || 'Select View'}
                          </div>
                          <div className="selector-actionsss">
                            <ChevronDown size={16} className={`dropdown-arrow ${isOpen ? 'rotate' : ''}`} />
                          </div>
                        </div>

                        {isOpen && (
                          <div className="subcompany-dropdownss">
                            <div className="dropdown-listsss">
                              {ccOptions.map((option) => (
                                <div
                                  key={option.value}
                                  className={`dropdown-itemss ${selectedCC === option.value ? 'selected' : ''}`}
                                  onClick={() => handleCCSelect(option.value)}
                                >
                                  <span>{option.label}</span>
                                  {selectedCC === option.value && (
                                    <Check size={14} className="check-iconn" />
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="flex-row width-100">
                      <Projects
                        usedFor="filter"
                        cssType="modern"
                        toggleProject={selectedName}
                        setToggleProject={setSelectedName}
                        subcompany={toggleCompany}
                        value="id"
                      />
                    </div>
                  </div>
                </div>
                <>
                  {isFiltersVisible &&

                    <div className="filters-header">

                      <button
                        onClick={toggleFilters}
                        className="toggle-filters-btn"
                        style={{
                          background: "black",
                          backdropFilter: 'blur(10px)',
                          border: '1px solid rgba(255, 255, 255, 0.3)',
                          borderRadius: '10px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: '8px 20px',
                          fontSize: '14px',
                          fontWeight: '600',
                          color: 'white',
                          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                          letterSpacing: '0.3px',
                          width: "5vw",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = 'black';
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'black';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {isFiltersVisible ? (
                          <>
                            <span style={{ fontSize: "12px" }}>Hide Filters</span>
                          </>
                        ) : (
                          <>
                            <span>Show Filters</span>
                            <Plus size={16} color="white" />
                          </>
                        )}
                      </button>
                    </div>
                  }
                </>
              </>
            )}

          </div>
          {!isFiltersVisible &&
            <>
              <div className="filters-header">
                <button
                  onClick={toggleFilters}
                  className="toggle-filters-btn"
                  style={{
                    background: "black",
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    borderRadius: '10px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 20px',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'white',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    letterSpacing: '0.3px',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'black';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'black';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  {isFiltersVisible ? (
                    <>
                      <Minus size={16} color="white" />
                      <span>Hide Filters</span>
                    </>
                  ) : (
                    <>
                      <span>Show Filters</span>
                      <Plus size={16} color="white" />
                    </>
                  )}
                </button>


              </div>
              <div className='filter-section-modern' style={{ marginBottom: !isFiltersVisible && "0px", gap: "5px" }}>
                {role === "Hr" || role === "Account" ? "" :
                  <div className="btn-cont" style={{ width: "25vw", gap: "5px", alignItems: "normal" }}>
                    <DownloadProjectAllDetails />
                    {role !== "ViewAccess" &&
                      <>
                        <AddProjectDetails getProjects={getProjects} subcompany={toggleCompany} />
                      </>
                    }
                    {/* {role === "Admin" &&
                  <UploadSiteProject getProject={getProjects} ProjectList={filteredProject} getContractorProjects={getProjects} />
                } */}
                  </div>
                }
                <div className="filter-stats">
                  <div className="stat-card-mini">
                    <span className="stat-icon">📊</span>
                    <div style={{ height: "100%" }}>
                      <div className="stat-labels">
                        <p >Total Records</p>
                      </div>
                      <div className="stat-values">
                        <p >{filteredProject?.length || 0}</p>
                      </div>
                    </div>
                  </div>
                </div>


                {/* <div className="view-toggle">
                  <button
                    className={`toggle-btn ${viewMode === 'table' ? 'active' : ''}`}
                    onClick={() => setViewMode('table')}
                  >
                    <LayoutGrid size={16} />
                    <span>Table</span>
                  </button>
                  <button
                    className={`toggle-btn ${viewMode === 'cards' ? 'active' : ''}`}
                    onClick={() => setViewMode('cards')}
                  >
                    <Columns size={16} />
                    <span>Cards</span>
                  </button>
                </div> */}


              </div>
            </>
          }
        </div>



        {/* Conditionally render the views based on selectedCC */}
        {selectedCC === 'contractor' ? (
          <ProjectContractorView
            viewMode={viewMode}
            setViewMode={setViewMode}
            subCompany={toggleCompany}
            searchName={selectedName}
            searchSort={sorting}
            projectList={projectList}
            filteredProject={filteredProject}
            getData={getProjects}
            buffering={buffering}
            isFiltersVisible={isFiltersVisible}

          />
        ) : (
          <ProjectConsultantView
            subCompany={toggleCompany}
            searchName={selectedName}
            searchSort={sorting}
          />
        )}
      </div >
    </>
  );
};





// const Detailspage = () => {


//   const siteRole = sessionStorage.getItem("sitemanagement_role")
//   const location = useLocation();
//   const { toggle = 1 } = location.state || {};
//   const [toggleState, setToggleState] = useState(toggle);
//   const getSelectedTitle = () => {
//     switch (toggleState) {

//       case 1:
//         return 'Site Progress';
//       case 2:
//         return 'Extension of Time';
//       case 3:
//         return 'Change of Scope';
//       case 4:
//         return 'Milestone Details';
//       case 5:
//         return 'Billing Details'
//       case 6:
//         return ' Bank Guarantee';
//       case 7:
//         return ' Insurance';
//       default:
//         return ' Site Progres';
//     }
//   };


//   return (
//     <>
//       <Dashboardnavbar name={getSelectedTitle()} url="Details Page" />


//       <div className='content-tabs'>
//         <div className="toggle-button-area" style={{}}>
//           <button
//             className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//             onClick={() => setToggleState(1)}
//           >
//             Progress
//           </button>
//           {
//             siteRole === "BD" ? "" :
//               <>
//                 <button
//                   className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                   onClick={() => setToggleState(2)}
//                 >
//                   EOT
//                 </button>


//                 <button
//                   className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//                   onClick={() => setToggleState(3)}
//                 >
//                   COS
//                 </button>
//               </>
//           }
//           <button
//             className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//             onClick={() => setToggleState(4)}
//           >
//             Milestone
//           </button>
//           <button
//             className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//             onClick={() => setToggleState(5)}
//           >
//             Billing
//           </button>
//           <button
//             className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//             onClick={() => setToggleState(6)}
//           >
//             Bank Guarantee
//           </button>
//           <button
//             className={toggleState === 7 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
//             onClick={() => setToggleState(7)}
//           >
//             Insurance
//           </button>
//         </div>
//       </div>

//       <div className="content-tabs">
//         {toggleState === 1 ? <Progressreport /> : null}
//         {toggleState === 2 ? <EOTDetails /> : null}
//         {toggleState === 3 ? <COSDetails /> : null}
//         {toggleState === 4 ? <MilestoneDetails /> : null}
//         {toggleState === 5 ? <BillingDetailsProgress /> : null}
//         {toggleState === 6 ? <BGDetails /> : null}
//         {toggleState === 7 ? <InsuranceDetails /> : null}
//       </div>
//     </>
//   );
// };

const Detailspage = () => {
  const siteRole = sessionStorage.getItem("sitemanagement_role");
  const location = useLocation();
  const { toggle = 1 } = location.state || {};
  const [toggleState, setToggleState] = useState(toggle);

  const getSelectedTitle = () => {
    switch (toggleState) {
      case 1: return 'Site Progress';
      case 2: return 'Extension of Time';
      case 3: return 'Change of Scope';
      case 4: return 'Milestone Details';
      case 5: return 'Billing Details';
      case 6: return 'Bank Guarantee';
      case 7: return 'Insurance';
      default: return 'Site Progress';
    }
  };

  // Tab configuration (same visibility logic as before)
  const getVisibleTabs = () => {
    let tabs = [
      { id: 1, label: 'Progress', icon: Activity, show: true },
    ];

    if (siteRole !== "BD") {
      tabs.push(
        { id: 2, label: 'EOT', icon: Clock, show: true },
        { id: 3, label: 'COS', icon: Award, show: true }
      );
    }

    tabs.push(
      { id: 4, label: 'Milestone', icon: Target, show: true },
      { id: 5, label: 'Billing', icon: FileText, show: true },
      { id: 6, label: 'Bank Guarantee', icon: Shield, show: true },
      { id: 7, label: 'Insurance', icon: ShieldCheck, show: true }
    );

    return tabs;
  };

  const visibleTabs = getVisibleTabs();

  const renderActiveComponent = () => {
    switch (toggleState) {
      case 1: return <Progressreport />;
      case 2: return <EOTDetails />;
      case 3: return <COSDetails />;
      case 4: return <MilestoneDetails />;
      case 5: return <BillingDetailsProgress />;
      case 6: return <BGDetails />;
      case 7: return <InsuranceDetails />;
      default: return null;
    }
  };

  return (
    <>

      <div className="project-details-modern">
        <div className="project-content-modern">
          {/* Modern Tabs */}
          <div className="modern-tabs-container">
            <div className="tabs-scroll">
              {visibleTabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    className={`modern-tab-btn ${toggleState === tab.id ? 'active' : ''}`}
                    onClick={() => setToggleState(tab.id)}
                  >
                    <Icon size={16} />
                    <span>{tab.label}</span>
                    {toggleState === tab.id && <div className="active-indicator" />}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Tab Content */}
          <div className="tab-content-modern">
            {renderActiveComponent()}
          </div>
        </div>
      </div>
    </>
  );
};


const ProjectCard = ({ project, index, onView, role, getData, DeleteProject, Lock }) => {
  const [expanded, setExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');
  const [expandedContractor, setExpandedContractor] = useState(null);
  const [expandedSections, setExpandedSections] = useState({});

  // Helper function to toggle sections
  const toggleSection = (contractorId, section) => {
    const key = `${contractorId}-${section}`;
    setExpandedSections(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const isSectionExpanded = (contractorId, section) => {
    const key = `${contractorId}-${section}`;
    return expandedSections[key] || false;
  };

  // Helper functions
  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatRoundoffCrores = (amount) => {
    if (!amount || amount === '-') return '-';
    const num = Number(amount);
    if (isNaN(num)) return '-';
    if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `${(num / 100000).toFixed(2)} L`;
    return num.toLocaleString();
  };

  const getProgressColor = (progress) => {
    if (progress >= 75) return '#10b981';
    if (progress >= 50) return '#f59e0b';
    if (progress >= 25) return '#f97316';
    return '#ef4444';
  };

  const getStatusBadge = (project) => {
    const hasPendingEOT = project.contractors?.some(c =>
      c.eots?.some(e => e.eot_status === 'pending')
    );
    const hasPendingCOS = project.contractors?.some(c =>
      c.coss?.some(co => co.cos_status === 'pending')
    );

    if (hasPendingEOT || hasPendingCOS) return { type: 'warning', text: 'Pending Action', icon: AlertCircle };
    if (project.contractors?.length === 0) return { type: 'danger', text: 'No Contractors', icon: XCircle };
    return { type: 'success', text: 'Active', icon: CheckCircle };
  };

  const calculateOverallProgress = () => {
    if (!project.contractors?.length) return 0;
    const totalProgress = project.contractors.reduce((sum, c) =>
      sum + (c.latest_progress?.physical_progress || 0), 0
    );
    return Math.round(totalProgress / project.contractors.length);
  };

  // Billing calculation functions
  const calculateSPSBills = (billingDetailsFields, contractorCost) => {
    const spsBills = billingDetailsFields || [];

    const totalWorkDone = spsBills.reduce((sum, bill) => sum + Number(bill.site_work_done_amt || 0), 0);
    const totalEscalation = spsBills.reduce((sum, bill) => sum + Number(bill.site_escalation || 0), 0);
    const totalLDAmount = spsBills.reduce((sum, bill) => sum + Number(bill.site_ld_amount || 0), 0);
    const totalWithheld = spsBills.reduce((sum, bill) => sum + Number(bill.site_withheld_amt || 0), 0);
    const totalWithheldReleased = spsBills.reduce((sum, bill) => sum + Number(bill.site_released_withheld_amt || 0), 0);

    const withheldAmount = totalWithheld - totalWithheldReleased;
    const remainingAmount = Number(contractorCost || 0) - totalWorkDone;

    return {
      totalWorkDone,
      totalEscalation,
      totalLDAmount,
      withheldAmount,
      remainingAmount,
      contractorCost: Number(contractorCost || 0),
      billCount: spsBills.length
    };
  };

  const calculateRABillsByCOS = (billingDetailsFields, coss) => {
    const raBills = billingDetailsFields?.filter(bill => bill.bill_type === 'ra') || [];
    const cosIdsFromBills = [...new Set(raBills.map(bill => bill.cos).filter(Boolean))];
    const cosMap = new Map();

    cosIdsFromBills.forEach(cosId => {
      const cos = coss?.find(c => c.id === cosId);
      if (cos) {
        let approvedAmount = 0;
        if (cos.cos_status === 'Approved') {
          approvedAmount = Number(cos.approved_amount || 0);
        } else if (cos.cos_status === 'inprinciple') {
          approvedAmount = Number(cos.in_principle_amount_byclient || 0);
        }

        cosMap.set(cos.id, {
          cosId: cos.id,
          cosCode: cos.cos_code,
          cosStatus: cos.cos_status,
          cosType: cos.cos_type,
          approvedAmount: approvedAmount,
          totalWorkDone: 0,
          totalEscalation: 0,
          totalLDAmount: 0,
          totalWithheld: 0,
          totalWithheldReleased: 0,
        });
      }
    });

    raBills.forEach(bill => {
      if (bill.cos && cosMap.has(bill.cos)) {
        const cosData = cosMap.get(bill.cos);
        cosData.totalWorkDone += Number(bill.site_work_done_amt || 0);
        cosData.totalEscalation += Number(bill.site_escalation || 0);
        cosData.totalLDAmount += Number(bill.site_ld_amount || 0);
        cosData.totalWithheld += Number(bill.site_withheld_amt || 0);
        cosData.totalWithheldReleased += Number(bill.site_released_withheld_amt || 0);
      }
    });

    const cosCalculations = [];
    for (const [cosId, cosData] of cosMap) {
      const withheldAmount = cosData.totalWithheld - cosData.totalWithheldReleased;
      const remainingAmount = cosData.approvedAmount - cosData.totalWorkDone;

      cosCalculations.push({
        ...cosData,
        withheldAmount,
        remainingAmount,
        billCount: raBills.filter(bill => bill.cos === cosId).length,
        isFullyUtilized: remainingAmount <= 0,
        utilizationPercentage: cosData.approvedAmount > 0
          ? ((cosData.totalWorkDone / cosData.approvedAmount) * 100).toFixed(1)
          : 0
      });
    }

    return cosCalculations;
  };

  const getBillSummary = (contractor) => {
    const billingFields = contractor.billing_details_fields || [];
    const coss = contractor.coss || [];
    const contractorCost = contractor.cost || 0;

    const spsSummary = calculateSPSBills(billingFields, contractorCost);
    const raSummary = calculateRABillsByCOS(billingFields, coss);

    return {
      sps: spsSummary,
      ra: raSummary,
      hasSPS: spsSummary.billCount > 0,
      hasRA: raSummary.length > 0,
      totalContractorCost: contractorCost
    };
  };

  // COS calculation
  const calcCOSBreakdown = (contractor) => {
    const baseCost = Number(contractor.cost || 0);
    const approvedCOS = (contractor.coss || []).filter(c => c.cos_status === "Approved");
    const inPrincipleCOS = (contractor.coss || []).filter(c => c.cos_status === "inprinciple");

    const workOrderTotal = approvedCOS.reduce((sum, cos) => {
      const amt = Number(cos.approved_amount || 0);
      return cos.cos_type === "negativecos" ? sum - amt : sum + amt;
    }, 0);

    const inPrincipleTotal = inPrincipleCOS.reduce((sum, cos) => {
      const amt = Number(cos.in_principle_amount_byclient || 0);
      return cos.cos_type === "negativecos" ? sum - amt : sum + amt;
    }, 0);

    return {
      baseCost,
      approvedCOS,
      inPrincipleCOS,
      workOrderTotal,
      inPrincipleTotal,
      revisedCostAfterWorkOrder: baseCost + workOrderTotal,
      revisedCostAfterInPrinciple: baseCost + workOrderTotal + inPrincipleTotal,
    };
  };

  // EOT calculation
  const calcEOTDateBreakdown = (contractor) => {
    const toDate = (d) => d ? new Date(d) : null;
    let schedConstDate = toDate(contractor.schedule_construction_completion_date);
    let schedCompDate = toDate(contractor.schedule_completion_date);

    const formatDate = (date) => {
      if (!date) return '-';
      const dd = String(date.getDate()).padStart(2, '0');
      const mmm = date.toLocaleString('en-IN', { month: 'short' });
      const yyyy = date.getFullYear();
      return `${dd}-${mmm}-${yyyy}`;
    };

    const approvedEOTs = (contractor.eots || [])
      .filter(eot => eot.eot_status === "Approved")
      .sort((a, b) => new Date(a.process_initiate_date) - new Date(b.process_initiate_date));

    return approvedEOTs.map((eot) => {
      const initiateDate = toDate(eot.process_initiate_date);
      const days = Number(eot.approved_days || 0);

      if (initiateDate <= schedConstDate) {
        schedConstDate = new Date(schedConstDate.getTime());
        schedConstDate.setDate(schedConstDate.getDate() + days);
      } else {
        schedCompDate = new Date(schedCompDate.getTime());
        schedCompDate.setDate(schedCompDate.getDate() + days);
      }

      return {
        eot_code: eot.eot_code,
        eot_status: eot.eot_status,
        days: eot.days,
        ae_approved_days: eot.ae_approved_days,
        approved_days: eot.approved_days,
        revised_const_completion_date: formatDate(schedConstDate),
        revised_completion_date: formatDate(schedCompDate),
        process_initiate_date: eot.process_initiate_date,
      };
    });
  };

  // Milestone status
  const getMilestoneStatus = (milestone) => {
    const actualDays = Number(milestone.actual_gap_days);
    const rescheduleDays = Number(milestone.reschedule_gap_days);
    const milestoneDays = Number(milestone.day);

    if (!milestone.milestone_as_per_actual) return "upcoming";

    if (milestone.reschedule_gap_days && rescheduleDays > 0) {
      return actualDays <= rescheduleDays ? "achieved" : "skipped";
    }

    return actualDays <= milestoneDays ? "achieved" : "skipped";
  };

  const overallProgress = calculateOverallProgress();
  const status = getStatusBadge(project);
  const StatusIcon = status.icon;

  return (
    <div className="project-card-modern" data-status={status.type}>
      {/* Card Header with Gradient */}
      <div className="card-header-premium">
        <div className="card-header-content">
          <div className="project-badge">
            <span className="badge-number">#{index + 1}</span>
            <span className={`status-badge ${status.type}`}>
              <StatusIcon size={12} />
              {status.text}
            </span>
          </div>
        </div>

        <div className="project-title-section">
          <div className="project-code-large">{project.site_prcode}</div>
          <h3 className="project-name-large" title={project.project_name}>
            {project.project_short_name || project.project_name}
          </h3>
          <div className="project-meta-grid">
            <div className="meta-chip">
              <Calendar size={12} />
              <span>Year {project.year || '-'}</span>
            </div>
            <div className="meta-chip">
              <Users size={12} />
              <span>{project.contractors?.length || 0} Contractors</span>
            </div>
          </div>
        </div>
      </div>

      {/* Overall Progress Section */}
      <div className="overall-progress-section">
        <div className="progress-ring-container">
          <svg className="progress-ring-large" width="80" height="80">
            <circle
              className="progress-ring-bg-large"
              stroke="#e2e8f0"
              strokeWidth="6"
              fill="none"
              r="34"
              cx="40"
              cy="40"
            />
            <circle
              className="progress-ring-fill-large"
              stroke={getProgressColor(overallProgress)}
              strokeWidth="6"
              fill="none"
              r="34"
              cx="40"
              cy="40"
              strokeDasharray={`${2 * Math.PI * 34}`}
              strokeDashoffset={`${2 * Math.PI * 34 * (1 - overallProgress / 100)}`}
              transform="rotate(-90 40 40)"
            />
            <text x="40" y="46" textAnchor="middle" className="progress-text-large">
              {overallProgress}%
            </text>
          </svg>
          <div className="progress-label">Overall Progress</div>
        </div>

        <div className="quick-stats">
          <div className="stat-block">
            <span className="stat-value-sm">
              ₹ {(
                (project?.contractors || []).reduce(
                  (sum, c) => sum + Number(c?.cost || 0),
                  0
                ) / 10000000
              ).toFixed(1)} Cr
            </span>
            <span className="stat-label-sm">Total Cost</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-block">
            <span className="stat-value-sm">
              {project.contractors?.filter(c => c.eots?.length).length || 0}
            </span>
            <span className="stat-label-sm">EOT Applied</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-block">
            <span className="stat-value-sm">
              {project.contractors?.filter(c => c.coss?.length).length || 0}
            </span>
            <span className="stat-label-sm">COS Applied</span>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="card-tabs">
        {['overview', 'contractors', 'milestones', 'billing', 'cos', 'eot'].map(tab => (
          <button
            key={tab}
            className={`tab-btnss ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab === 'overview' && <Activity size={14} />}
            {tab === 'contractors' && <Users size={14} />}
            {tab === 'milestones' && <Target size={14} />}
            {tab === 'billing' && <IndianRupee size={14} />}
            {tab === 'cos' && <FileText size={14} />}
            {tab === 'eot' && <Clock size={14} />}
            <span>{tab.charAt(0).toUpperCase() + tab.slice(1)}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="card-tab-content">
        {/* Overview Tab */}
        {activeTab === 'overview' && (
          <div className="overview-content">
            {project.contractors?.slice(0, expanded ? undefined : 2).map((contractor, idx) => {
              const billSummary = getBillSummary(contractor);
              const cosSummary = calcCOSBreakdown(contractor);

              return (
                <div key={idx} className="contractor-preview-card">
                  <div className="preview-header">
                    <Building2 size={14} />
                    <strong>{contractor.name || `Contractor ${idx + 1}`}</strong>
                  </div>
                  <div className="preview-progress">
                    <div className="mini-progress-bar">
                      <div
                        className="mini-progress-fill"
                        style={{ width: `${contractor.latest_progress?.physical_progress || 0}%`, background: getProgressColor(contractor.latest_progress?.physical_progress || 0) }}
                      />
                    </div>
                    <span>{contractor.latest_progress?.physical_progress || 0}%</span>
                  </div>
                  <div className="preview-stats">
                    <div className="preview-stat">
                      <span>Cost:</span>
                      <strong>{formatRoundoffCrores(contractor.cost)}</strong>
                    </div>
                    <div className="preview-stat">
                      <span>Billed:</span>
                      <strong>{formatRoundoffCrores(billSummary.sps.totalWorkDone)}</strong>
                    </div>
                    <div className="preview-stat">
                      <span>Remaining:</span>
                      <strong>{formatRoundoffCrores(billSummary.sps.remainingAmount)}</strong>
                    </div>
                  </div>
                  {contractor.latest_progress?.month && (
                    <div className="preview-date">
                      Updated: {contractor.latest_progress?.month}/{contractor.latest_progress?.year}
                    </div>
                  )}
                </div>
              );
            })}
            {project.contractors?.length > 2 && !expanded && (
              <button className="expand-link" onClick={() => setExpanded(true)}>
                <ChevronDown size={14} /> View {project.contractors.length - 2} more
              </button>
            )}
            {expanded && project.contractors?.length > 2 && (
              <button className="expand-link" onClick={() => setExpanded(false)}>
                <ChevronUp size={14} /> Show less
              </button>
            )}
          </div>
        )}

        {/* Contractors Tab - Detailed */}
        {activeTab === 'contractors' && (
          <div className="contractors-detailed-list">
            {project.contractors?.map((contractor, idx) => {
              const isExpanded = expandedContractor === idx;
              const billSummary = getBillSummary(contractor);
              const cosSummary = calcCOSBreakdown(contractor);
              const eotBreakdown = calcEOTDateBreakdown(contractor);

              return (
                <div key={idx} className="contractor-detailed-card">
                  <div
                    className="contractor-detailed-header"
                    onClick={() => setExpandedContractor(isExpanded ? null : idx)}
                  >
                    <div className="contractor-avatar-large">
                      <Building2 size={20} />
                    </div>
                    <div className="contractor-detailed-info">
                      <div className="contractor-name-large">{contractor.name || 'Unnamed Contractor'}</div>
                      <div className="contractor-meta">
                        <span>LOA: {formatDate(contractor.loa_award_date)}</span>
                        <span>Agreement: {formatDate(contractor.agreement_date)}</span>
                      </div>
                    </div>
                    <div className="contractor-progress-indicator">
                      <div className="progress-circle-small">
                        <svg width="40" height="40">
                          <circle cx="20" cy="20" r="16" fill="none" stroke="#e2e8f0" strokeWidth="3" />
                          <circle
                            cx="20" cy="20" r="16" fill="none"
                            stroke={getProgressColor(contractor.latest_progress?.physical_progress || 0)}
                            strokeWidth="3"
                            strokeDasharray={`${2 * Math.PI * 16}`}
                            strokeDashoffset={`${2 * Math.PI * 16 * (1 - (contractor.latest_progress?.physical_progress || 0) / 100)}`}
                            transform="rotate(-90 20 20)"
                          />
                          <text x="20" y="24" textAnchor="middle" fontSize="10" fontWeight="bold">
                            {contractor.latest_progress?.physical_progress || 0}%
                          </text>
                        </svg>
                      </div>
                      <ChevronDown size={16} className={`expand-icon ${isExpanded ? 'rotated' : ''}`} />
                    </div>
                  </div>

                  {isExpanded && (
                    <div className="contractor-detailed-content">
                      {/* Basic Details */}
                      <div className="details-section">
                        <div className="section-title">Contractor Details</div>
                        <div className="details-grid">
                          <div className="detail-item">
                            <span>Const. Completion Date:</span>
                            <strong>{formatDate(contractor.actual_construction_completion_date !== null ? contractor.actual_construction_completion_date : contractor?.schedule_construction_completion_date)}</strong>
                          </div>
                          <div className="detail-item">
                            <span>Completion Date:</span>
                            <strong>{formatDate(contractor?.actual_completion_date !== null ? contractor?.actual_completion_date : contractor?.schedule_completion_date)}</strong>
                          </div>
                          <div className="detail-item highlight">
                            <span>Construction Cost:</span>
                            <strong>₹ {formatRoundoffCrores(contractor?.cost)}</strong>
                          </div>
                        </div>
                      </div>

                      {/* Milestones */}
                      {contractor.milestone_details?.length > 0 && (
                        <div className="details-section">
                          <div className="section-title">Milestones ({contractor.milestone_details.length})</div>
                          <div className="milestones-mini-list">
                            {contractor.milestone_details.slice(0, 3).map((ms, msIdx) => {
                              const status = getMilestoneStatus(ms);
                              return (
                                <div key={msIdx} className={`milestone-mini-item status-${status}`}>
                                  <div className="milestone-mini-name">{ms.milestone_name}</div>
                                  <div className="milestone-mini-date">{formatDate(ms.milestone_date)}</div>
                                  <span className={`milestone-mini-badge ${status}`}>
                                    {status === 'achieved' ? '✓' : status === 'skipped' ? '✗' : '○'}
                                  </span>
                                </div>
                              );
                            })}
                            {contractor.milestone_details.length > 3 && (
                              <div className="more-indicator">+{contractor.milestone_details.length - 3} more</div>
                            )}
                          </div>
                        </div>
                      )}

                      {/* Quick Stats */}
                      <div className="quick-stats-grid">
                        <div className="quick-stat">
                          <span className="stat-label">Total Billed</span>
                          <span className="stat-value">{formatRoundoffCrores(billSummary.sps.totalWorkDone)}</span>
                        </div>
                        <div className="quick-stat">
                          <span className="stat-label">Total COS</span>
                          <span className="stat-value">{cosSummary.approvedCOS.length + cosSummary.inPrincipleCOS.length}</span>
                        </div>
                        <div className="quick-stat">
                          <span className="stat-label">Total EOT Days</span>
                          <span className="stat-value">{contractor.eots?.filter(e => e.eot_status === 'Approved').reduce((sum, e) => sum + Number(e.approved_days || 0), 0) || 0}</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            {(!project.contractors || project.contractors.length === 0) && (
              <div className="empty-state-card">
                <Users size={32} />
                <p>No contractors added yet</p>
                <AddContractor
                  projectId={project.id}
                  getProjects={getData}
                  getProjectContractorDetails={getData}
                  getDetails={getData}
                />
              </div>
            )}
          </div>
        )}

        {/* Milestones Tab */}
        {activeTab === 'milestones' && (
          <div className="milestones-tab-content">
            {project.contractors?.map((contractor, idx) => (
              <div key={idx} className="contractor-milestones-section">
                <div className="contractor-section-header">
                  <Building2 size={14} />
                  <span>{contractor.name || `Contractor ${idx + 1}`}</span>
                  <span className="milestone-count">{contractor.milestone_details?.length || 0} milestones</span>
                </div>
                {contractor.milestone_details?.length > 0 ? (
                  <div className="milestones-stack">
                    {[...contractor.milestone_details]
                      .sort((a, b) => Number(a.day) - Number(b.day))
                      .map((ms, msIdx) => {
                        const status = getMilestoneStatus(ms);
                        return (
                          <div key={msIdx} className={`milestone-card status-${status}`}>
                            <div className="milestone-card-header">
                              <div className={`milestone-icon status-${status}`}>
                                {status === "achieved" && <CheckCircle size={12} />}
                                {status === "skipped" && <XCircle size={12} />}
                                {status === "upcoming" && <Clock size={12} />}
                              </div>
                              <span className="milestone-name">{ms.milestone_name}</span>
                              <span className={`milestone-status-badge ${status}`}>
                                {status === "achieved" ? "Achieved" : status === "skipped" ? "Skipped" : "Upcoming"}
                              </span>
                            </div>
                            <div className="milestone-card-body">
                              <div className="milestone-date">
                                <Calendar size={10} />
                                <span>Planned: {formatDate(ms.milestone_date)}</span>
                              </div>
                              {ms.milestone_as_per_actual && (
                                <div className="milestone-date actual">
                                  <CalendarCheck size={10} />
                                  <span>Actual: {formatDate(ms.milestone_as_per_actual)}</span>
                                </div>
                              )}
                              <div className="milestone-footer">
                                <span className="milestone-day">Day {ms.day}</span>
                                {ms.actual_gap_days && (
                                  <span className={`milestone-gap ${status === 'achieved' ? 'success' : 'warning'}`}>
                                    Gap: {ms.actual_gap_days}d
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <div className="empty-state-mini">No milestones assigned</div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Billing Tab - Complete */}
        {activeTab === 'billing' && (
          <div className="billing-tab-content">
            {project.contractors?.map((contractor, idx) => {
              const billSummary = getBillSummary(contractor);

              return (
                <div key={idx} className="contractor-billing-section">
                  <div className="contractor-section-header">
                    <Building2 size={14} />
                    <span>{contractor.name || `Contractor ${idx + 1}`}</span>
                  </div>

                  {(billSummary.hasSPS || billSummary.hasRA) ? (
                    <div className="billing-detailed-container">
                      {/* SPS Section */}
                      {billSummary.hasSPS && (
                        <div className="billing-card sps">
                          <div className="billing-card-header">
                            <span className="billing-type sps">CA Billing Tracker</span>
                            <span className="bill-count">{billSummary.sps.billCount} bill(s)</span>
                          </div>
                          <div className="billing-details-grid">
                            <div className="billing-row">
                              <span>Work Done Amount:</span>
                              <strong>{formatRoundoffCrores(billSummary.sps.totalWorkDone)}</strong>
                            </div>
                            <div className="billing-row">
                              <span>Escalation Amount:</span>
                              <strong>{formatRoundoffCrores(billSummary.sps.totalEscalation)}</strong>
                            </div>
                            <div className="billing-row negative">
                              <span>LD Amount:</span>
                              <strong>{formatRoundoffCrores(billSummary.sps.totalLDAmount)}</strong>
                            </div>
                            <div className="billing-row">
                              <span>Withheld Amount:</span>
                              <strong>{formatRoundoffCrores(billSummary.sps.withheldAmount)}</strong>
                            </div>
                            <div className="billing-row total">
                              <span>Remaining Amount:</span>
                              <strong className="highlight">{formatRoundoffCrores(billSummary.sps.remainingAmount)}</strong>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* RA Section */}
                      {billSummary.hasRA && (
                        <div className="billing-card ra">
                          <div className="billing-card-header">
                            <span className="billing-type ra">COS Billing Tracker</span>
                          </div>
                          {billSummary.ra.map((cosBill, raIdx) => (
                            <div key={raIdx} className="cos-billing-mini">
                              <div className="cos-billing-mini-header">
                                <span className="cos-code">{cosBill.cosCode}</span>
                                <span className={`cos-status ${cosBill.cosStatus}`}>{cosBill.cosStatus}</span>
                                <span className="cos-bill-count">{cosBill.billCount} RA bill(s)</span>
                              </div>
                              <div className="billing-details-grid compact">
                                <div className="billing-row">
                                  <span>Work Done:</span>
                                  <strong>{formatRoundoffCrores(cosBill.totalWorkDone)}</strong>
                                </div>
                                <div className="billing-row total">
                                  <span>Remaining:</span>
                                  <strong className={cosBill.remainingAmount < 0 ? 'negative' : 'highlight'}>
                                    {formatRoundoffCrores(cosBill.remainingAmount)}
                                  </strong>
                                </div>
                              </div>
                              {cosBill.isFullyUtilized && (
                                <div className="utilization-warning-mini">⚠️ COS fully utilized</div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="empty-state-mini">No billing details</div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* COS Tab - Complete */}
        {activeTab === 'cos' && (
          <div className="cos-tab-content">
            {project.contractors?.map((contractor, idx) => {
              const { baseCost, approvedCOS, inPrincipleCOS, revisedCostAfterWorkOrder } = calcCOSBreakdown(contractor);

              return (
                <div key={idx} className="contractor-cos-section">
                  <div className="contractor-section-header">
                    <Building2 size={14} />
                    <span>{contractor.name || `Contractor ${idx + 1}`}</span>
                  </div>

                  {(approvedCOS.length > 0 || inPrincipleCOS.length > 0) ? (
                    <div className="cos-detailed-container">
                      {/* Base Cost */}
                      <div className="cos-base-card">
                        <span>💰 Base Cost</span>
                        <strong>₹ {formatRoundoffCrores(baseCost)}</strong>
                      </div>

                      {/* Work Order COS */}
                      {approvedCOS.length > 0 && (
                        <div className="cos-group">
                          <div className="cos-group-header workorder">
                            <span>📋 Work Order COS ({approvedCOS.length})</span>
                          </div>
                          {approvedCOS.map(cos => (
                            <div key={cos.id} className="cos-item">
                              <div className="cos-item-header">
                                <strong>{cos.cos_code}</strong>
                                <span className={`cos-type ${cos.cos_type === "negativecos" ? "neg" : "pos"}`}>
                                  {cos.cos_type === "negativecos" ? "▼ Negative" : "▲ Positive"}
                                </span>
                              </div>
                              <div className="cos-amounts">
                                <div>
                                  <span>Initiated:</span>
                                  <span>₹{formatRoundoffCrores(Number(cos.cos_type === "negativecos" ? cos.negativeamount : cos.amount))}</span>
                                </div>
                                <div>
                                  <span>AE Approved:</span>
                                  <span>₹{formatRoundoffCrores(Number(cos.ae_approved_amount || 0))}</span>
                                </div>
                                <div className="approved">
                                  <span>Client Approved:</span>
                                  <span>{cos.cos_type === "negativecos" ? "−" : "+"}₹{formatRoundoffCrores(Number(cos.approved_amount || 0))}</span>
                                </div>
                              </div>
                            </div>
                          ))}
                          <div className="cos-revised-total">
                            <span>🏁 Revised Cost after W.O</span>
                            <strong>₹ {formatRoundoffCrores(revisedCostAfterWorkOrder)}</strong>
                          </div>
                        </div>
                      )}

                      {/* In Principle COS */}
                      {inPrincipleCOS.length > 0 && (
                        <div className="cos-group">
                          <div className="cos-group-header inprinciple">
                            <span>🔖 In Principle COS ({inPrincipleCOS.length})</span>
                          </div>
                          {inPrincipleCOS.map(cos => (
                            <div key={cos.id} className="cos-item">
                              <div className="cos-item-header">
                                <strong>{cos.cos_code}</strong>
                                <span className={`cos-type ${cos.cos_type === "negativecos" ? "neg" : "pos"}`}>
                                  {cos.cos_type === "negativecos" ? "▼ Negative" : "▲ Positive"}
                                </span>
                              </div>
                              <div className="cos-amounts">
                                <div>
                                  <span>Initiated:</span>
                                  <span>₹{formatRoundoffCrores(Number(cos.cos_type === "negativecos" ? cos.negativeamount : cos.amount))}</span>
                                </div>
                                <div>
                                  <span>AE Approved:</span>
                                  <span>₹{formatRoundoffCrores(Number(cos.ae_approved_amount || 0))}</span>
                                </div>
                                <div className="approved">
                                  <span>In Principle:</span>
                                  <span>{cos.cos_type === "negativecos" ? "−" : "+"}₹{formatRoundoffCrores(Number(cos.in_principle_amount_byclient || 0))}</span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="empty-state-mini">No COS records</div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* EOT Tab - Complete */}
        {activeTab === 'eot' && (
          <div className="eot-tab-content">
            {project.contractors?.map((contractor, idx) => {
              const approvedEOTs = contractor.eots?.filter(eot => eot.eot_status === "Approved") || [];
              const eotBreakdown = calcEOTDateBreakdown(contractor);

              return (
                <div key={idx} className="contractor-eot-section">
                  <div className="contractor-section-header">
                    <Building2 size={14} />
                    <span>{contractor.name || `Contractor ${idx + 1}`}</span>
                    <span className="eot-count">{approvedEOTs.length} EOT(s)</span>
                  </div>

                  {approvedEOTs.length > 0 ? (
                    <div className="eot-detailed-container">
                      {eotBreakdown.map((eot, eotIdx) => (
                        <div key={eotIdx} className="eot-detailed-card">
                          <div className="eot-detailed-header">
                            <strong>{eot.eot_code}</strong>
                            <span className="eot-status approved">Approved</span>
                          </div>
                          <div className="eot-days-detailed">
                            <div>
                              <span>Requested:</span>
                              <strong>{eot.days || '-'} d</strong>
                            </div>
                            <div>
                              <span>AE Recommended:</span>
                              <strong>{eot.ae_approved_days || '-'} d</strong>
                            </div>
                            <div className="approved">
                              <span>Client Approved:</span>
                              <strong>{eot.approved_days || '-'} d</strong>
                            </div>
                          </div>
                          <div className="eot-revised-dates">
                            <div>
                              <span>📅 Revised Const. Date:</span>
                              <strong>{eot.revised_const_completion_date}</strong>
                            </div>
                            <div>
                              <span>🏁 Revised Completion:</span>
                              <strong className="highlight">{eot.revised_completion_date}</strong>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="empty-state-mini">No EOT records</div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Card Footer with Actions */}
      <div className="card-footer-premium">
        <button className="action-btn-primary" onClick={() => onView(project)}>
          <Eye size={16} />
          View Full Details
        </button>

        {role === "Admin" && (
          <div className="admin-actions">
            <Lock
              apiName="project"
              id={project.id}
              i={project}
              usedFor="Project"
              getData={getData}
            />
            {project.lock === false && (
              <DeleteProject i={project} fetchContractorProjects={getData} />
            )}
          </div>
        )}
      </div>

      {/* Floating Notification Badge for pending items */}
      {(project.contractors?.some(c => c.eots?.some(e => e.eot_status === "pending")) ||
        project.contractors?.some(c => c.coss?.some(co => co.cos_status === "pending"))) && (
          <div className="pending-badge">
            <Bell size={12} />
            <span>Pending Approval</span>
          </div>
        )}
    </div>
  );
};





const ProjectContractorView = ({ isFiltersVisible, viewMode, setViewMode, subCompany, searchName, searchSort, projectList, setProjectsList, filteredProject, getData, buffering }) => {
  // State declarations
  // Add this state at the beginning of your ProjectContractorView component
  const [expandedSections, setExpandedSections] = useState({});

  // Helper function to toggle sections
  const toggleSection = (contractorId, section) => {
    const key = `${contractorId}-${section}`;
    setExpandedSections(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Helper to check if section is expanded
  const isSectionExpanded = (contractorId, section) => {
    const key = `${contractorId}-${section}`;
    return expandedSections[key] || false;
  };
  const [expandedDetails, setExpandedDetails] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const tableRef = useRef(null);
  const role = sessionStorage.getItem('sitemanagement_role');

  // Helper function to toggle details
  const toggleDetails = (key) => {
    setExpandedDetails(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Helper function to get progress color
  const getProgressColor = (progress) => {
    if (progress >= 75) return '#10b981';
    if (progress >= 50) return '#f59e0b';
    if (progress >= 25) return '#f97316';
    return '#ef4444';
  };

  // Helper function to format date
  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  // Helper function to format currency
  const formatRoundoffCrores = (amount) => {
    if (!amount || amount === '-') return '-';
    const num = Number(amount);
    if (isNaN(num)) return '-';
    if (num >= 10000000) return `${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `${(num / 100000).toFixed(2)} L`;
    return num.toLocaleString();
  };

  const formatRoundoff = (amount) => {
    if (!amount) return '-';
    return amount.toLocaleString('en-IN');
  };

  // UPDATED: Function to calculate SPS bills - Simplified version
  const calculateSPSBills = (billingDetailsFields, contractorCost) => {
    const spsBills = billingDetailsFields || [];

    const totalWorkDone = spsBills.reduce((sum, bill) => sum + Number(bill.site_work_done_amt || 0), 0);
    const totalEscalation = spsBills.reduce((sum, bill) => sum + Number(bill.site_escalation || 0), 0);
    const totalLDAmount = spsBills.reduce((sum, bill) => sum + Number(bill.site_ld_amount || 0), 0);
    const totalWithheld = spsBills.reduce((sum, bill) => sum + Number(bill.site_withheld_amt || 0), 0);
    const totalWithheldReleased = spsBills.reduce((sum, bill) => sum + Number(bill.site_released_withheld_amt || 0), 0);

    // Withheld amount = sum of Withheld amount - sum of withheld release amount
    const withheldAmount = totalWithheld - totalWithheldReleased;

    // Remaining amount = contractor cost - workdone amount
    const remainingAmount = Number(contractorCost || 0) - totalWorkDone;

    return {
      totalWorkDone,
      totalEscalation,
      totalLDAmount,
      withheldAmount,
      remainingAmount,
      contractorCost: Number(contractorCost || 0),
      billCount: spsBills.length
    };
  };

  // UPDATED: Function to calculate RA bills grouped by COS - Only COS linked in billing details
  const calculateRABillsByCOS = (billingDetailsFields, coss) => {
    const raBills = billingDetailsFields?.filter(bill => bill.bill_type === 'ra') || [];

    // Get unique COS IDs from RA bills
    const cosIdsFromBills = [...new Set(raBills.map(bill => bill.cos).filter(Boolean))];

    // Create a map of COS ID to COS details - only for COS that have RA bills
    const cosMap = new Map();

    // Only include COS that are linked in billing details
    cosIdsFromBills.forEach(cosId => {
      const cos = coss?.find(c => c.id === cosId);
      if (cos) {
        // Get the approved amount based on COS status
        let approvedAmount = 0;
        if (cos.cos_status === 'Approved') {
          approvedAmount = Number(cos.approved_amount || 0);
        } else if (cos.cos_status === 'inprinciple') {
          approvedAmount = Number(cos.in_principle_amount_byclient || 0);
        }

        cosMap.set(cos.id, {
          cosId: cos.id,
          cosCode: cos.cos_code,
          cosStatus: cos.cos_status,
          cosType: cos.cos_type,
          approvedAmount: approvedAmount,
          totalWorkDone: 0,
          totalEscalation: 0,
          totalLDAmount: 0,
          totalWithheld: 0,
          totalWithheldReleased: 0,
        });
      }
    });

    // Group RA bills by COS ID and calculate totals
    raBills.forEach(bill => {
      if (bill.cos && cosMap.has(bill.cos)) {
        const cosData = cosMap.get(bill.cos);
        cosData.totalWorkDone += Number(bill.site_work_done_amt || 0);
        cosData.totalEscalation += Number(bill.site_escalation || 0);
        cosData.totalLDAmount += Number(bill.site_ld_amount || 0);
        cosData.totalWithheld += Number(bill.site_withheld_amt || 0);
        cosData.totalWithheldReleased += Number(bill.site_released_withheld_amt || 0);
      }
    });

    // Calculate remaining amount and withheld amount for each COS
    const cosCalculations = [];
    for (const [cosId, cosData] of cosMap) {
      // Withheld amount = sum of Withheld amount - sum of withheld release amount
      const withheldAmount = cosData.totalWithheld - cosData.totalWithheldReleased;

      // Remaining amount = approved_amount - workdone amount
      const remainingAmount = cosData.approvedAmount - cosData.totalWorkDone;

      cosCalculations.push({
        ...cosData,
        withheldAmount,
        remainingAmount,
        billCount: raBills.filter(bill => bill.cos === cosId).length,
        isFullyUtilized: remainingAmount <= 0,
        utilizationPercentage: cosData.approvedAmount > 0
          ? ((cosData.totalWorkDone / cosData.approvedAmount) * 100).toFixed(1)
          : 0
      });
    }

    return cosCalculations;
  };

  // UPDATED: Function to get bill summary for display
  const getBillSummary = (contractor, contractMode) => {
    const billingFields = contractor.billing_details_fields || [];
    const coss = contractor.coss || [];
    const contractorCost = contractor.cost || 0;

    const isHAMorBOT = ['ham', 'bot'].includes(contractMode?.toLowerCase());

    // HAM/BOT → milestonebill, EPC → sps
    const filteredFields = billingFields.filter(bill =>
      isHAMorBOT ? bill.bill_type === 'milestonebill' : bill.bill_type === 'sps'
    );

    const spsSummary = calculateSPSBills(filteredFields, contractorCost);
    const raSummary = calculateRABillsByCOS(billingFields, coss);

    return {
      sps: spsSummary,
      ra: raSummary,
      hasSPS: spsSummary.billCount > 0,
      hasRA: raSummary.length > 0,
      totalContractorCost: contractorCost
    };
  };

  function calcEOTDate(contractor) {
    const toDate = (d) => d ? new Date(d) : null;

    const scheduleConstructionCompletionDate = contractor.schedule_construction_completion_date;
    const scheduleCompletionDate = contractor.schedule_completion_date;
    const actualConstructionCompletionDate = contractor.actual_construction_completion_date;

    const approveDaysBeforeOM = contractor.eots
      ?.filter(eot => eot.eot_status === "Approved" && actualConstructionCompletionDate === null)
      .reduce((sum, eot) => sum + Number(eot.approved_days || 0), 0) || 0;

    const approveDaysONOM = contractor.eots
      ?.filter(eot => eot.eot_status === "Approved" && eot.process_initiate_date > actualConstructionCompletionDate)
      .reduce((sum, eot) => sum + Number(eot.approved_days || 0), 0) || 0;

    const schedConstr = toDate(scheduleConstructionCompletionDate);
    const schedComp = toDate(scheduleCompletionDate);
    const actualConstr = toDate(actualConstructionCompletionDate);

    const useSchedComp = actualConstr !== null;

    const baseDate = useSchedComp ? schedComp : schedConstr;
    const baseDays = useSchedComp ? approveDaysONOM : approveDaysBeforeOM;

    const newDate = new Date(baseDate);
    newDate.setDate(newDate.getDate() + baseDays);

    const dd = String(newDate.getDate()).padStart(2, '0');
    const mmm = newDate.toLocaleString('en-IN', { month: 'short' });
    const yyyy = newDate.getFullYear();

    return `${dd}-${mmm}-${yyyy}`;
  }

  const getMilestoneStatus = (milestone, appointedDate, gracePeriod = 0) => {
    if (!milestone.milestone_as_per_actual) return "upcoming";

    const rescheduleVal = milestone.milestone_as_per_reschedule
      ? milestone.rescedule_gap_days
      : null;

    const effectiveDeadline = getEffectiveDeadline(appointedDate, milestone.day, rescheduleVal, gracePeriod);
    if (!effectiveDeadline) return "upcoming";

    const actualDate = new Date(milestone.milestone_as_per_actual);
    const baseDate = milestone.milestone_as_per_reschedule
      ? new Date(milestone.milestone_as_per_reschedule)
      : new Date(milestone.milestone_date);

    if (actualDate <= baseDate) return "achieved";
    if (actualDate <= effectiveDeadline) return "grace";
    return "skipped";
  };

  const getEffectiveDeadline = (appointedDate, days, rescheduleGapDays, gracePeriod = 0) => {
    if (!appointedDate) return null;
    const baseDays = (rescheduleGapDays !== null && rescheduleGapDays !== undefined && rescheduleGapDays !== "")
      ? rescheduleGapDays
      : days;
    if (baseDays === null || baseDays === undefined) return null;
    const [year, month, day] = appointedDate.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + Number(baseDays) + Number(gracePeriod));
    return date;
  };

  function calcEOTDateBreakdown(contractor) {
    const toDate = (d) => d ? new Date(d) : null;

    let schedConstDate = toDate(contractor.schedule_construction_completion_date);
    let schedCompDate = toDate(contractor.schedule_completion_date);

    const formatDate = (date) => {
      if (!date) return '-';
      const dd = String(date.getDate()).padStart(2, '0');
      const mmm = date.toLocaleString('en-IN', { month: 'short' });
      const yyyy = date.getFullYear();
      return `${dd}-${mmm}-${yyyy}`;
    };

    const approvedEOTs = (contractor.eots || [])
      .filter(eot => eot.eot_status === "Approved")
      .sort((a, b) => new Date(a.process_initiate_date) - new Date(b.process_initiate_date));

    return approvedEOTs.map((eot) => {
      const initiateDate = toDate(eot.process_initiate_date);
      const days = Number(eot.approved_days || 0);

      if (initiateDate <= schedConstDate) {
        schedConstDate = new Date(schedConstDate.getTime());
        schedConstDate.setDate(schedConstDate.getDate() + days);
      } else {
        schedCompDate = new Date(schedCompDate.getTime());
        schedCompDate.setDate(schedCompDate.getDate() + days);
      }

      return {
        eot_code: eot.eot_code,
        eot_status: eot.eot_status,
        days: eot.days,
        ae_approved_days: eot.ae_approved_days,
        approved_days: eot.approved_days,
        revised_const_completion_date: formatDate(schedConstDate),
        revised_completion_date: formatDate(schedCompDate),
        process_initiate_date: eot.process_initiate_date,
      };
    });
  }

  function calcFinalEOTDates(contractor) {
    const toDate = (d) => d ? new Date(d) : null;

    let schedConstDate = toDate(contractor.schedule_construction_completion_date);
    let schedCompDate = toDate(contractor.schedule_completion_date);

    const formatDate = (date) => {
      if (!date) return '-';
      const dd = String(date.getDate()).padStart(2, '0');
      const mmm = date.toLocaleString('en-IN', { month: 'short' });
      const yyyy = date.getFullYear();
      return `${dd}-${mmm}-${yyyy}`;
    };

    const approvedEOTs = (contractor.eots || [])
      .filter(eot => eot.eot_status === "Approved")
      .sort((a, b) => new Date(a.process_initiate_date) - new Date(b.process_initiate_date));

    for (const eot of approvedEOTs) {
      const initiateDate = toDate(eot.process_initiate_date);
      const days = Number(eot.approved_days || 0);

      if (initiateDate <= schedConstDate) {
        schedConstDate = new Date(schedConstDate.getTime());
        schedConstDate.setDate(schedConstDate.getDate() + days);
      } else {
        schedCompDate = new Date(schedCompDate.getTime());
        schedCompDate.setDate(schedCompDate.getDate() + days);
      }
    }

    return {
      revisedConstDate: formatDate(schedConstDate),
      revisedCompDate: formatDate(schedCompDate),
    };
  }

  function calcCOSBreakdown(contractor) {
    const baseCost = Number(contractor.cost || 0);

    const approvedCOS = (contractor.coss || []).filter(c => c.cos_status === "Approved");
    const inPrincipleCOS = (contractor.coss || []).filter(c => c.cos_status === "inprinciple");

    const workOrderTotal = approvedCOS.reduce((sum, cos) => {
      const amt = Number(cos.approved_amount || 0);
      return cos.cos_type === "negativecos" ? sum - amt : sum + amt;
    }, 0);

    const inPrincipleTotal = inPrincipleCOS.reduce((sum, cos) => {
      const amt = Number(cos.in_principle_amount_byclient || 0);
      return cos.cos_type === "negativecos" ? sum - amt : sum + amt;
    }, 0);

    return {
      baseCost,
      approvedCOS,
      inPrincipleCOS,
      workOrderTotal,
      inPrincipleTotal,
      revisedCostAfterWorkOrder: baseCost + workOrderTotal,
      revisedCostAfterInPrinciple: baseCost + workOrderTotal + inPrincipleTotal,
    };
  }

  const [buffer, setBuffering] = useState(false);
  const navigate = useNavigate();

  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const toggleshow = "Contractor";

  const ViewAllProjectDetails = (project) => {
    navigate(`/${urlParts[3]}/ProjectAllDetails/`, {
      state: { project, toggleshow },
    });
  };

  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);



  return (
    <div className="site-tables-container">
      {/* Filter Section */}
      {isFiltersVisible &&
        <div className='filter-section-modern'>
          <div className="stats-container">
            {role === "Hr" || role === "Account" ? "" :
              <div className="btn-cont" style={{ width: "50%", gap: "5px", alignItems: "normal" }}>
                <DownloadProjectAllDetails />
                {role !== "ViewAccess" &&
                  <AddProjectDetails getProjects={getData} subcompany={subCompany} />
                }
              </div>
            }
            <div className="filter-stats">
              <div className="stat-card-mini">
                <span className="stat-icon">📊</span>
                <div style={{ height: "100%" }}>
                  <div className="stat-labels">
                    <p >Total Records</p>
                  </div>
                  <div className="stat-values">
                    <p >{filteredProject?.length || 0}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="view-toggle">
              <button
                className={`toggle-btn ${viewMode === 'table' ? 'active' : ''}`}
                onClick={() => setViewMode('table')}
              >
                <LayoutGrid size={16} />
                <span>Table</span>
              </button>
              <button
                className={`toggle-btn ${viewMode === 'cards' ? 'active' : ''}`}
                onClick={() => setViewMode('cards')}
              >
                <Columns size={16} />
                <span>Cards</span>
              </button>
            </div> */}
          </div>
        </div>
      }

      {viewMode === 'table' ? (
        <div className="table-container-premium scroll-container-table">
          <table ref={tableRef} className="premium-table">
            <thead>
              <tr className="premium-table-header">
                <th className="header-cell">
                  <div className="header-content">
                    <span>#</span>
                  </div>
                </th>
                <th className="header-cell">
                  <div className="header-content">
                    <span>Project</span>
                    <Search size={12} style={{ background: "transparent", color: "white" }} />
                  </div>
                </th>
                {(role === "Admin" || role === "DataEntryOperator") &&
                  <th className="header-cell">
                    <div className="header-content">
                      <span style={{ width: "11vw" }}>Additional Comments</span>
                      <MessageCircle size={12} style={{ background: "transparent", color: "white" }} />
                    </div>
                  </th>
                }
                <th className="header-cell">
                  <div className="header-content">
                    <span style={{ width: "8vw" }}>View Drawings</span>
                    <PencilRuler size={12} style={{ background: "transparent", color: "white" }} />
                  </div>
                </th>
                <th className="header-cell">
                  <div className="header-content text-center" style={{ justifyContent: "center" }} >
                    <span>Progress</span>
                    <TrendingUp size={12} />
                  </div>
                </th>
                <th className="header-cell">
                  <div className="header-content text-center" style={{ justifyContent: "center" }}>
                    <span className="text-center">Milestones</span>
                    <Target size={12} />
                  </div>
                </th>
                <th className="header-cell">
                  <div className="header-content">
                    <span>Project Details</span>
                    <BarChart size={12} />
                  </div>
                </th>

                {role === "Hr" ? null : (
                  <th className="header-cell">
                    <div className="header-content text-center" style={{ justifyContent: "center" }}>
                      <span>Billing</span>
                      <IndianRupee size={12} />
                    </div>
                  </th>
                )}
                <th className="header-cell">
                  <div className="header-content text-center" style={{ justifyContent: "center" }}>
                    <span>COS</span>
                    <FileText size={12} />
                  </div>
                </th>
                <th className="header-cell">
                  <div className="header-content text-center" style={{ justifyContent: "center" }}>
                    <span>EOT</span>
                    <Clock size={12} />
                  </div>
                </th>
                <th className="header-cell">
                  <div className="header-content text-center" style={{ justifyContent: "center" }}>
                    <span>Letters</span>
                    <Mail size={12} />
                  </div>
                </th>
                <th className="header-cell">
                  <div className="header-content text-center" style={{ justifyContent: "center" }}>
                    <span>Actions</span>
                    <Workflow size={12} />
                  </div>
                </th>
              </tr>
            </thead>

            {buffering && (
              <tbody>
                <tr>
                  <td colSpan="9">
                    <div className="skeleton-loader">
                      {[...Array(5)].map((_, i) => (
                        <div key={i} className="skeleton-row">
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                          <div className="skeleton-cell"></div>
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
              </tbody>
            )}

            <tbody>
              {filteredProject?.sort((a, b) => {
                if (a.year === b.year) return b.month - a.month;
                return b.year - a.year;
              }).map((project, index) => {
                const contractorCount = project?.contractors?.length || 1;

                return (
                  <Fragment key={project.id}>
                    {project?.contractors?.length > 0 ? (
                      // project?.contractors?.map((contractor, contractorIndex) => {
                      //   const detailsKey = `${project.id}-${contractorIndex}`;

                      //   // Get bill summary for this contractor
                      //   const billSummary = getBillSummary(contractor);

                      //   return (
                      //     <tr key={`${project.id}-${contractorIndex}`} className="premium-table-row">
                      //       {contractorIndex === 0 && (
                      //         <>
                      //           <td className="cell-index" rowSpan={contractorCount}>
                      //             <div className="index-container">
                      //               <span className="index-number">{index + 1}</span>
                      //               {contractorCount > 1 && (
                      //                 <span className="contractor-badge">{contractorCount}</span>
                      //               )}
                      //             </div>
                      //           </td>
                      //           <td className="cell-project" rowSpan={contractorCount}>
                      //             <div className="project-info">
                      //               <div className="project-header">
                      //                 <span className="project-code">{project?.site_prcode}</span>
                      //               </div>
                      //               <div className="project-name" title={project?.project_name}>
                      //                 {project?.project_short_name}
                      //               </div>
                      //               <div className="project-meta">
                      //                 <span className="meta-item">
                      //                   <Calendar size={12} />
                      //                   {project?.year || '-'}
                      //                 </span>
                      //               </div>
                      //             </div>
                      //           </td>
                      //         </>
                      //       )}

                      //       {/* Progress Column */}
                      //       <td className="cell-progress">
                      //         <ProgressBarGraph
                      //           contractor={contractor}
                      //           contractorName={contractor?.name}
                      //         />
                      //       </td>

                      //       {/* Milestone Column */}
                      //       <td className="cell-milestone-premium">
                      //         {contractor.milestone_details?.length > 0 ? (
                      //           <div className="milestone-stack">
                      //             {[...contractor.milestone_details]
                      //               .sort((a, b) => Number(a.day) - Number(b.day))
                      //               .map((ms, idx) => {
                      //                 const status = getMilestoneStatus(ms);
                      //                 const hasReschedule = ms.milestone_as_per_reschedule;
                      //                 const compareDays = hasReschedule
                      //                   ? Number(ms.reschedule_gap_days)
                      //                   : Number(ms.day);
                      //                 const actualDays = Number(ms.actual_gap_days);
                      //                 const gapOk = ms.milestone_as_per_actual
                      //                   ? actualDays <= compareDays
                      //                   : null;

                      //                 const progressPercent = ms.milestone_percentage ||
                      //                   (ms.milestone_as_per_actual ? 100 : status === 'upcoming' ? 0 :
                      //                     status === 'achieved' ? 100 : 50);

                      //                 return (
                      //                   <div
                      //                     key={ms.id}
                      //                     className={`ms-card ms-${status}`}
                      //                     style={{
                      //                       animation: `fadeInUp 0.3s ease-out ${idx * 0.05}s both`
                      //                     }}
                      //                   >
                      //                     <div className="ms-card-top">
                      //                       <div className={`ms-icon ms-icon-${status}`}>
                      //                         {status === "achieved" && <CheckCircle size={14} />}
                      //                         {status === "skipped" && <XCircle size={14} />}
                      //                         {status === "upcoming" && <Clock size={14} />}
                      //                       </div>
                      //                       <span className="ms-name" title={ms.milestone_name}>
                      //                         {ms.milestone_name?.length > 22
                      //                           ? ms.milestone_name.slice(0, 22) + "…"
                      //                           : ms.milestone_name}
                      //                       </span>
                      //                       <span className={`ms-badge ms-badge-${status}`}>
                      //                         {status === "achieved"
                      //                           ? "✓ Achieved"
                      //                           : status === "skipped"
                      //                             ? "✗ Skipped"
                      //                             : "○ Upcoming"}
                      //                       </span>
                      //                     </div>

                      //                     <div className="ms-body">
                      //                       <div className="ms-row">
                      //                         <Calendar size={11} />
                      //                         <span>
                      //                           Planned:&nbsp;
                      //                           <strong>{formatDate(ms.milestone_date)}</strong>
                      //                         </span>
                      //                       </div>

                      //                       {hasReschedule && (
                      //                         <div className="ms-row">
                      //                           <RefreshCw size={11} />
                      //                           <span>
                      //                             Rescheduled:&nbsp;
                      //                             <strong>{formatDate(ms.milestone_as_per_reschedule)}</strong>
                      //                           </span>
                      //                         </div>
                      //                       )}

                      //                       {ms.milestone_as_per_actual ? (
                      //                         <>
                      //                           <div className="ms-divider" />
                      //                           <div className="ms-row">
                      //                             <CalendarCheck size={11} />
                      //                             <span>
                      //                               Actual:&nbsp;
                      //                               <strong>{formatDate(ms.milestone_as_per_actual)}</strong>
                      //                             </span>
                      //                           </div>
                      //                         </>
                      //                       ) : (
                      //                         <div className="ms-row muted">
                      //                           <span>⏳ No actual date recorded</span>
                      //                         </div>
                      //                       )}
                      //                     </div>

                      //                     <div className="ms-footer">
                      //                       <span className="ms-chip">
                      //                         📍 Day {ms.day}
                      //                       </span>
                      //                       {ms.milestone_percentage && (
                      //                         <span className="ms-chip">
                      //                           📊 {ms.milestone_percentage}%
                      //                         </span>
                      //                       )}
                      //                       {ms.actual_gap_days && gapOk !== null && (
                      //                         <span className={`ms-chip ${gapOk ? "ms-chip-ok" : "ms-chip-warn"}`}>
                      //                           {gapOk ? "✅" : "⚠️"} Gap: {ms.actual_gap_days}d
                      //                           <span style={{ fontSize: '9px', marginLeft: '2px' }}>
                      //                             ({gapOk ? "≤" : ">"} {compareDays}d)
                      //                           </span>
                      //                         </span>
                      //                       )}
                      //                     </div>

                      //                     <div style={{
                      //                       height: '2px',
                      //                       background: '#e2e8f0',
                      //                       width: '100%',
                      //                       position: 'relative'
                      //                     }}>
                      //                       <div style={{
                      //                         position: 'absolute',
                      //                         top: 0,
                      //                         left: 0,
                      //                         height: '100%',
                      //                         width: `${progressPercent}%`,
                      //                         background: status === 'achieved' ? '#10b981' :
                      //                           status === 'skipped' ? '#ef4444' : '#3b82f6',
                      //                         transition: 'width 0.4s ease'
                      //                       }} />
                      //                     </div>
                      //                   </div>
                      //                 );
                      //               })}
                      //           </div>
                      //         ) : (
                      //           <div className="empty-state-premium">
                      //             <span style={{ fontSize: '24px', display: 'block', marginBottom: '8px' }}>📋</span>
                      //             No Milestones Assigned
                      //           </div>
                      //         )}
                      //       </td>

                      //       {/* Details Column */}
                      //       <td className="cell-details-premium">
                      //         {contractor.loa_award_date || contractor.name ? (
                      //           <div className="details-accordion">
                      //             <div className="details-summary" onClick={() => toggleDetails(detailsKey)}>
                      //               <div className="contractor-name-premium">
                      //                 <Building2 size={14} />
                      //                 <span>{contractor?.name || 'Unnamed Contractor'}</span>
                      //               </div>
                      //               <button className="expand-btn">
                      //                 {expandedDetails[detailsKey] ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                      //               </button>
                      //             </div>
                      //             {expandedDetails[detailsKey] && (
                      //               <div className="details-expanded">
                      //                 <div className="detail-item">
                      //                   <span className="detail-icon">📅</span>
                      //                   <div className="text-start">
                      //                     <small>LOA Award Date</small>
                      //                     <strong>{formatDate(contractor?.loa_award_date) || '-'}</strong>
                      //                   </div>
                      //                 </div>
                      //                 <div className="detail-item">
                      //                   <span className="detail-icon">📄</span>
                      //                   <div className="text-start">
                      //                     <small>Agreement Date</small>
                      //                     <strong>{formatDate(contractor?.agreement_date) || '-'}</strong>
                      //                   </div>
                      //                 </div>
                      //                 <div className="detail-item">
                      //                   <span className="detail-icon">📄</span>
                      //                   <div className="text-start">
                      //                     <small>Appointed Date</small>
                      //                     <strong>{formatDate(contractor?.commencement_date) || '-'}</strong>
                      //                   </div>
                      //                 </div>
                      //                 <div className="detail-item">
                      //                   <span className="detail-icon">⏰</span>
                      //                   <div className="text-start">
                      //                     <small>Const. Completion Date</small>
                      //                     <strong>{formatDate(contractor.actual_construction_completion_date !== null ? contractor.actual_construction_completion_date : contractor?.schedule_construction_completion_date) || '-'}</strong>
                      //                   </div>
                      //                 </div>
                      //                 <div className="detail-item">
                      //                   <span className="detail-icon">⏰</span>
                      //                   <div className="text-start">
                      //                     <small>Completion Date</small>
                      //                     <strong>{formatDate(contractor?.actual_completion_date !== null ? contractor?.actual_completion_date : contractor?.schedule_completion_date) || '-'}</strong>
                      //                   </div>
                      //                 </div>
                      //                 <div className="detail-item highlight">
                      //                   <span className="detail-icon">💰</span>
                      //                   <div className="text-start">
                      //                     <small>Construction Cost</small>
                      //                     <strong>₹ {formatRoundoffCrores(contractor?.cost) || '-'}</strong>
                      //                   </div>
                      //                 </div>

                      //                 {/* EOT Revised Dates */}
                      //                 {contractor.eots?.filter(c => c.eot_status === 'Approved').length > 0 && (() => {
                      //                   const { revisedConstDate, revisedCompDate } = calcFinalEOTDates(contractor);
                      //                   return (
                      //                     <>
                      //                       <div className="detail-item highlight">
                      //                         <span className="detail-icon">⏰</span>
                      //                         <div className="text-start">
                      //                           <small>Revised Const. Completion Date</small>
                      //                           <strong>{revisedConstDate}</strong>
                      //                         </div>
                      //                       </div>
                      //                       <div className="detail-item highlight">
                      //                         <span className="detail-icon">🏁</span>
                      //                         <div className="text-start">
                      //                           <small>Revised Completion Date</small>
                      //                           <strong>{revisedCompDate}</strong>
                      //                         </div>
                      //                       </div>
                      //                     </>
                      //                   );
                      //                 })()}

                      //                 {/* COS Revised Cost */}
                      //                 {contractor.coss?.filter(c => c.cos_status === 'Approved' || c.cos_status === 'inprinciple').length > 0 && (() => {
                      //                   const { revisedCostAfterWorkOrder, approvedCOS } = calcCOSBreakdown(contractor);
                      //                   return (
                      //                     <>
                      //                       {approvedCOS.length > 0 && (
                      //                         <div className="detail-item highlight">
                      //                           <span className="detail-icon">💰</span>
                      //                           <div className="text-start">
                      //                             <small>Revised Cost After W.O COS</small>
                      //                             <strong>₹ {formatRoundoffCrores(revisedCostAfterWorkOrder) || '-'}</strong>
                      //                           </div>
                      //                         </div>
                      //                       )}
                      //                     </>
                      //                   );
                      //                 })()}
                      //               </div>
                      //             )}
                      //           </div>
                      //         ) : (
                      //           <div className="empty-state-premium">No details</div>
                      //         )}
                      //       </td>

                      //       {/* Billing Column - Enhanced with corrected calculations */}
                      //       {/* Billing Column - Simplified with only requested fields */}
                      //       <td className="cell-billing-premium">
                      //         {(billSummary.hasSPS || billSummary.hasRA) ? (
                      //           <div className="billing-enhanced-container">

                      //             {/* SPS Section - Simplified */}
                      //             {billSummary.hasSPS && (
                      //               <div className="billing-section sps-section">
                      //                 <div className="billing-section-header">
                      //                   <span className="billing-type-badge sps">CA Billing Tracker </span>
                      //                   <span className="billing-bill-count">{billSummary.sps.billCount} bill(s)</span>
                      //                 </div>

                      //                 <div className="billing-fields-simple">
                      //                   <div className="billing-field-row">
                      //                     <span className="field-label">Work Done Amount:</span>
                      //                     <span className="field-value">{formatRoundoffCrores(billSummary.sps.totalWorkDone)}</span>
                      //                   </div>
                      //                   <div className="billing-field-row">
                      //                     <span className="field-label">Escalation Amount:</span>
                      //                     <span className="field-value">{formatRoundoffCrores(billSummary.sps.totalEscalation)}</span>
                      //                   </div>
                      //                   <div className="billing-field-row">
                      //                     <span className="field-label">LD Amount:</span>
                      //                     <span className="field-value negative">{formatRoundoffCrores(billSummary.sps.totalLDAmount)}</span>
                      //                   </div>
                      //                   <div className="billing-field-row">
                      //                     <span className="field-label">Withheld Amount:</span>
                      //                     <span className="field-value">{formatRoundoffCrores(billSummary.sps.withheldAmount)}</span>
                      //                   </div>
                      //                   <div className="billing-field-row total-row">
                      //                     <span className="field-label">Remaining Amount:</span>
                      //                     <span className="field-value highlight">{formatRoundoffCrores(billSummary.sps.remainingAmount)}</span>
                      //                   </div>
                      //                 </div>
                      //               </div>
                      //             )}

                      //             {/* RA Section - Only COS linked in billing details */}
                      //             {billSummary.hasRA && (
                      //               <div className="billing-section ra-section">
                      //                 <div className="billing-section-header">
                      //                   <span className="billing-type-badge ra">RA Bills (by COS)</span>
                      //                 </div>
                      //                 {billSummary.ra.map((cosBill, idx) => (
                      //                   <div key={cosBill.cosId} className="cos-billing-card">
                      //                     <div className="cos-billing-header">
                      //                       <div className="cos-info">
                      //                         <span className="cos-billing-code">{cosBill.cosCode}</span>
                      //                         <span className={`cos-status-badge ${cosBill.cosStatus}`}>
                      //                           {cosBill.cosStatus}
                      //                         </span>
                      //                       </div>
                      //                       <span className="cos-billing-count">{cosBill.billCount} RA bill(s)</span>
                      //                     </div>

                      //                     <div className="billing-fields-simple">
                      //                       <div className="billing-field-row">
                      //                         <span className="field-label">Work Done Amount:</span>
                      //                         <span className="field-value">{formatRoundoffCrores(cosBill.totalWorkDone)}</span>
                      //                       </div>
                      //                       <div className="billing-field-row">
                      //                         <span className="field-label">Escalation Amount:</span>
                      //                         <span className="field-value">{formatRoundoffCrores(cosBill.totalEscalation)}</span>
                      //                       </div>
                      //                       <div className="billing-field-row">
                      //                         <span className="field-label">LD Amount:</span>
                      //                         <span className="field-value negative">{formatRoundoffCrores(cosBill.totalLDAmount)}</span>
                      //                       </div>
                      //                       <div className="billing-field-row">
                      //                         <span className="field-label">Withheld Amount:</span>
                      //                         <span className="field-value">{formatRoundoffCrores(cosBill.withheldAmount)}</span>
                      //                       </div>
                      //                       <div className="billing-field-row total-row">
                      //                         <span className="field-label">Remaining Amount:</span>
                      //                         <span className={`field-value ${cosBill.remainingAmount < 0 ? 'negative' : 'highlight'}`}>
                      //                           {formatRoundoffCrores(cosBill.remainingAmount)}
                      //                         </span>
                      //                       </div>
                      //                       {cosBill.isFullyUtilized && (
                      //                         <div className="utilization-warning">
                      //                           ⚠️ COS fully utilized or exceeded
                      //                         </div>
                      //                       )}
                      //                     </div>
                      //                   </div>
                      //                 ))}
                      //               </div>
                      //             )}

                      //           </div>
                      //         ) : (
                      //           <div className="empty-state-premium">No Billing Details</div>
                      //         )}
                      //       </td>

                      //       {/* COS Column */}
                      //       <td className="cell-cos-premium">
                      //         {contractor.coss?.filter(c => c.cos_status === "Approved" || c.cos_status === "inprinciple").length > 0 ? (
                      //           (() => {
                      //             const {
                      //               baseCost,
                      //               approvedCOS,
                      //               inPrincipleCOS,
                      //               revisedCostAfterWorkOrder,
                      //             } = calcCOSBreakdown(contractor);

                      //             return (
                      //               <div className="cos-breakdown-container">
                      //                 {/* Base Cost */}
                      //                 <div className="cos-base-cost-card">
                      //                   <div className="cos-base-left">
                      //                     <span className="cos-base-icon">💼</span>
                      //                     <span className="cos-base-label">Base Cost</span>
                      //                   </div>
                      //                   <span className="cos-base-value">₹ {formatRoundoffCrores(baseCost)}</span>
                      //                 </div>

                      //                 {/* Work Order COS */}
                      //                 {approvedCOS.length > 0 && (
                      //                   <div className="cos-section">
                      //                     <div className="cos-section-header workorder">
                      //                       <span className="cos-section-icon">📋</span>
                      //                       <span>Work Order COS</span>
                      //                       <span className="cos-count-badge wo">{approvedCOS.length}</span>
                      //                     </div>
                      //                     {approvedCOS.map(cos => (
                      //                       <div key={cos.id} className="cos-item-card">
                      //                         <div className="cos-card-header">
                      //                           <div className="cos-code-wrap">
                      //                             <span className="cos-dot wo"></span>
                      //                             <strong className="cos-code-text">{cos.cos_code}</strong>
                      //                           </div>
                      //                           <span className={`cos-type-pill ${cos.cos_type === "negativecos" ? "neg" : "pos"}`}>
                      //                             {cos.cos_type === "negativecos" ? "▼ Neg" : "▲ Pos"}
                      //                           </span>
                      //                         </div>

                      //                         <div className="cos-amounts-grid">
                      //                           <div className="cos-amt-cell">
                      //                             <span className="cos-amt-label">Initiated</span>
                      //                             <span className="cos-amt-value neutral">
                      //                               ₹{formatRoundoffCrores(Number(
                      //                                 cos.cos_type === "negativecos"
                      //                                   ? (cos.negativeamount || 0)
                      //                                   : (cos.amount || 0)
                      //                               ))}
                      //                             </span>
                      //                           </div>
                      //                           <div className="cos-amt-cell">
                      //                             <span className="cos-amt-label">AE Approved</span>
                      //                             <span className="cos-amt-value ae">
                      //                               ₹{formatRoundoffCrores(Number(cos.ae_approved_amount || 0))}
                      //                             </span>
                      //                           </div>
                      //                           <div className={`cos-amt-cell final ${cos.cos_type === "negativecos" ? "neg-bg" : "pos-bg"}`}>
                      //                             <span className="cos-amt-label">Approved</span>
                      //                             <span className={`cos-amt-value ${cos.cos_type === "negativecos" ? "negative" : "positive"}`}>
                      //                               {cos.cos_type === "negativecos" ? "−" : "+"}₹{formatRoundoffCrores(Number(cos.approved_amount || 0))}
                      //                             </span>
                      //                           </div>
                      //                         </div>
                      //                       </div>
                      //                     ))}

                      //                     <div className="cos-revised-total wo">
                      //                       <div className="cos-revised-left">
                      //                         <span>🏁</span>
                      //                         <span>Revised Cost after W.O</span>
                      //                       </div>
                      //                       <span className="cos-revised-amount wo">₹ {formatRoundoffCrores(revisedCostAfterWorkOrder)}</span>
                      //                     </div>
                      //                   </div>
                      //                 )}

                      //                 {/* In Principle COS */}
                      //                 {inPrincipleCOS.length > 0 && (
                      //                   <div className="cos-section">
                      //                     <div className="cos-section-header inprinciple">
                      //                       <span className="cos-section-icon">🔖</span>
                      //                       <span>In Principle COS</span>
                      //                       <span className="cos-count-badge ip">{inPrincipleCOS.length}</span>
                      //                     </div>
                      //                     {inPrincipleCOS.map(cos => (
                      //                       <div key={cos.id} className="cos-item-card">
                      //                         <div className="cos-card-header">
                      //                           <div className="cos-code-wrap">
                      //                             <span className="cos-dot ip"></span>
                      //                             <strong className="cos-code-text">{cos.cos_code}</strong>
                      //                           </div>
                      //                           <span className={`cos-type-pill ${cos.cos_type === "negativecos" ? "neg" : "pos"}`}>
                      //                             {cos.cos_type === "negativecos" ? "▼ Neg" : "▲ Pos"}
                      //                           </span>
                      //                         </div>

                      //                         <div className="cos-amounts-grid">
                      //                           <div className="cos-amt-cell">
                      //                             <span className="cos-amt-label">Initiated</span>
                      //                             <span className="cos-amt-value neutral">
                      //                               ₹{formatRoundoffCrores(Number(
                      //                                 cos.cos_type === "negativecos"
                      //                                   ? (cos.negativeamount || 0)
                      //                                   : (cos.amount || 0)
                      //                               ))}
                      //                             </span>
                      //                           </div>
                      //                           <div className="cos-amt-cell">
                      //                             <span className="cos-amt-label">AE Approved</span>
                      //                             <span className="cos-amt-value ae">
                      //                               ₹{formatRoundoffCrores(Number(cos.ae_approved_amount || 0))}
                      //                             </span>
                      //                           </div>
                      //                           <div className={`cos-amt-cell final ${cos.cos_type === "negativecos" ? "neg-bg" : "pos-bg"}`}>
                      //                             <span className="cos-amt-label">In Principle</span>
                      //                             <span className={`cos-amt-value ${cos.cos_type === "negativecos" ? "negative" : "positive"}`}>
                      //                               {cos.cos_type === "negativecos" ? "−" : "+"}₹{formatRoundoffCrores(Number(cos.in_principle_amount_byclient || 0))}
                      //                             </span>
                      //                           </div>
                      //                         </div>
                      //                       </div>
                      //                     ))}
                      //                   </div>
                      //                 )}
                      //               </div>
                      //             );
                      //           })()
                      //         ) : (
                      //           <div className="empty-state-premium">No COS</div>
                      //         )}
                      //       </td>

                      //       {/* EOT Column */}
                      //       <td className="cell-eot-premium">
                      //         {contractor.eots?.filter(eot => eot.eot_status === "Approved")?.length > 0 ? (
                      //           <div className="eot-timeline">
                      //             {(() => {
                      //               const breakdown = calcEOTDateBreakdown(contractor);

                      //               return contractor.eots
                      //                 .filter(eot => eot.eot_status === "Approved")
                      //                 .sort((a, b) => new Date(a.process_initiate_date) - new Date(b.process_initiate_date))
                      //                 .map((eot) => {
                      //                   const bdItem = breakdown.find(b => b.eot_code === eot.eot_code);

                      //                   return (
                      //                     <div key={eot.eot_code} className="eot-card-new">
                      //                       <div className="eot-card-header">
                      //                         <strong className="eot-code-label">{eot.eot_code}</strong>
                      //                         <span className="eot-status-badge approved">
                      //                           {eot.eot_status}
                      //                         </span>
                      //                       </div>

                      //                       <div className="eot-days-grid">
                      //                         <div className="eot-day-item">
                      //                           <span className="eot-day-label">Requested</span>
                      //                           <span className="eot-day-value requested">{eot.days ?? '-'} d</span>
                      //                         </div>
                      //                         <div className="eot-day-item">
                      //                           <span className="eot-day-label">AE Approved</span>
                      //                           <span className="eot-day-value ae">{eot.ae_approved_days ?? '-'} d</span>
                      //                         </div>
                      //                         <div className="eot-day-item">
                      //                           <span className="eot-day-label">Approved</span>
                      //                           <span className="eot-day-value approved">{eot.approved_days ?? '-'} d</span>
                      //                         </div>
                      //                       </div>

                      //                       {bdItem && (
                      //                         <div className="eot-revised-dates">
                      //                           <div className="eot-date-row">
                      //                             <span className="eot-date-label">📅 Rev. Const. Date</span>
                      //                             <span className="eot-date-value">{bdItem.revised_const_completion_date}</span>
                      //                           </div>
                      //                           <div className="eot-date-row">
                      //                             <span className="eot-date-label">🏁 Rev. Completion</span>
                      //                             <span className="eot-date-value highlight">{bdItem.revised_completion_date}</span>
                      //                           </div>
                      //                         </div>
                      //                       )}
                      //                     </div>
                      //                   );
                      //                 });
                      //             })()}
                      //           </div>
                      //         ) : (
                      //           <div className="empty-state-premium">No EOT</div>
                      //         )}
                      //       </td>

                      //       <td className="cell-letters-premium">
                      //         <LetterButton contractor={contractor} project={project} />
                      //       </td>

                      //       {/* Actions Column */}
                      //       {contractorIndex === 0 && (
                      //         <td className="cell-actions-premium" rowSpan={contractorCount}>
                      //           <div className="action-group">
                      //             <button
                      //               onClick={() => ViewAllProjectDetails(project)}
                      //               className="action-icon view"
                      //               title="View Details"
                      //             >
                      //               <Eye size={18} />
                      //               <span className="action-tooltip">View Details</span>
                      //             </button>

                      //             {role === "Admin" && (
                      //               <>
                      //                 <div className="action-divider"></div>
                      //                 <Lock
                      //                   apiName="project"
                      //                   id={project.id}
                      //                   i={project}
                      //                   usedFor="Project"
                      //                   getData={getData}
                      //                 />
                      //                 {project.lock === false && (
                      //                   <DeleteProject
                      //                     i={project}
                      //                     fetchContractorProjects={getData}
                      //                   />
                      //                 )}
                      //               </>
                      //             )}
                      //           </div>
                      //         </td>
                      //       )}
                      //     </tr>
                      //   );
                      // })

                      // project?.contractors?.map((contractor, contractorIndex) => {
                      //   const contractorId = contractor.id || `${project.id}-${contractorIndex}`;
                      //   const detailsKey = `${project.id}-${contractorIndex}`;

                      //   //   // Get bill summary for this contractor
                      //   const billSummary = getBillSummary(contractor);
                      //   return (
                      //     <Fragment key={contractorId}>
                      //       {/* Main Row */}
                      //       <tr className="premium-table-row">
                      //         {contractorIndex === 0 && (
                      //           <>
                      //             <td className="cell-index" rowSpan={contractorCount}>
                      //               <div className="index-container">
                      //                 <span className="index-number">{index + 1}</span>
                      //                 {contractorCount > 1 && (
                      //                   <span className="contractor-badge">{contractorCount}</span>
                      //                 )}
                      //               </div>
                      //             </td>
                      //             <td className="cell-project" rowSpan={contractorCount}>
                      //               <div className="project-info">
                      //                 <div className="project-header">
                      //                   <span className="project-code">{project?.site_prcode}</span>
                      //                 </div>
                      //                 <div className="project-name" title={project?.project_name}>
                      //                   {project?.project_short_name}
                      //                 </div>
                      //                 <div className="project-meta">
                      //                   <span className="meta-item">
                      //                     <Calendar size={12} />
                      //                     {project?.year || '-'}
                      //                   </span>
                      //                 </div>
                      //               </div>
                      //             </td>
                      //           </>
                      //         )}

                      //         {/* Progress Cell - Expandable */}
                      //         <td className="cell-progress">
                      //           <div className="expandable-section">
                      //             <div
                      //               className="section-header clickable"
                      //               onClick={() => toggleSection(contractorId, 'progress')}
                      //             >
                      //               <span className="section-title">Progress Overview</span>
                      //               <button className="expand-btn">
                      //                 {isSectionExpanded(contractorId, 'progress') ?
                      //                   <ChevronUp size={16} /> : <ChevronDown size={16} />
                      //                 }
                      //               </button>
                      //             </div>
                      //             {isSectionExpanded(contractorId, 'progress') && (
                      //               <div className="section-content">
                      //                 <ProgressBarGraph
                      //                   contractor={contractor}
                      //                   contractorName={contractor?.name}
                      //                 />
                      //               </div>
                      //             )}
                      //           </div>
                      //         </td>

                      //         {/* Milestone Cell - Expandable */}
                      //         <td className="cell-milestone-premium">
                      //           <div className="expandable-section">
                      //             <div
                      //               className="section-header clickable"
                      //               onClick={() => toggleSection(contractorId, 'milestone')}
                      //             >
                      //               <span className="section-title">
                      //                 Milestones ({contractor.milestone_details?.length || 0})
                      //               </span>
                      //               <button className="expand-btn">
                      //                 {isSectionExpanded(contractorId, 'milestone') ?
                      //                   <ChevronUp size={16} /> : <ChevronDown size={16} />
                      //                 }
                      //               </button>
                      //             </div>
                      //             {isSectionExpanded(contractorId, 'milestone') && (
                      //               <div className="section-content">
                      //                 {contractor.milestone_details?.length > 0 ? (
                      //                   <div className="milestone-stack">
                      //                     {[...contractor.milestone_details]
                      //                       .sort((a, b) => Number(a.day) - Number(b.day))
                      //                       .map((ms, idx) => {
                      //                         const status = getMilestoneStatus(ms);
                      //                         // ... rest of your milestone rendering code
                      //                         return (
                      //                           <div key={ms.id} className={`ms-card ms-${status}`}>
                      //                             {/* Milestone card content */}
                      //                           </div>
                      //                         );
                      //                       })}
                      //                   </div>
                      //                 ) : (
                      //                   <div className="empty-state-premium">
                      //                     <span>📋</span>
                      //                     <p>No Milestones Assigned</p>
                      //                   </div>
                      //                 )}
                      //               </div>
                      //             )}
                      //           </div>
                      //         </td>


                      //         {/* Contractor Details Cell - Expandable */}
                      //         <td className="cell-details-premium">
                      //           <div className="expandable-section">
                      //             <div
                      //               className="section-header clickable"
                      //               onClick={() => toggleSection(contractorId, 'details')}
                      //             >
                      //               <div className="contractor-name-premium">
                      //                 <Building2 size={14} />
                      //                 <span>{contractor?.name || 'Unnamed Contractor'}</span>
                      //               </div>
                      //               <button className="expand-btn">
                      //                 {isSectionExpanded(contractorId, 'details') ?
                      //                   <ChevronUp size={14} /> : <ChevronDown size={14} />
                      //                 }
                      //               </button>
                      //             </div>
                      //             {isSectionExpanded(contractorId, 'details') && (
                      //               <div className="section-content">
                      //                 <div className="details-expanded">
                      //                   <div className="detail-item">
                      //                     <span className="detail-icon">📅</span>
                      //                     <div className="text-start">
                      //                       <small>LOA Award Date</small>
                      //                       <strong>{formatDate(contractor?.loa_award_date) || '-'}</strong>
                      //                     </div>
                      //                   </div>
                      //                   <div className="detail-item">
                      //                     <span className="detail-icon">📄</span>
                      //                     <div className="text-start">
                      //                       <small>Agreement Date</small>
                      //                       <strong>{formatDate(contractor?.agreement_date) || '-'}</strong>
                      //                     </div>
                      //                   </div>
                      //                   <div className="detail-item">
                      //                     <span className="detail-icon">📄</span>
                      //                     <div className="text-start">
                      //                       <small>Appointed Date</small>
                      //                       <strong>{formatDate(contractor?.commencement_date) || '-'}</strong>
                      //                     </div>
                      //                   </div>
                      //                   <div className="detail-item">
                      //                     <span className="detail-icon">⏰</span>
                      //                     <div className="text-start">
                      //                       <small>Const. Completion Date</small>
                      //                       <strong>{formatDate(contractor.actual_construction_completion_date !== null ? contractor.actual_construction_completion_date : contractor?.schedule_construction_completion_date) || '-'}</strong>
                      //                     </div>
                      //                   </div>
                      //                   <div className="detail-item">
                      //                     <span className="detail-icon">⏰</span>
                      //                     <div className="text-start">
                      //                       <small>Completion Date</small>
                      //                       <strong>{formatDate(contractor?.actual_completion_date !== null ? contractor?.actual_completion_date : contractor?.schedule_completion_date) || '-'}</strong>
                      //                     </div>
                      //                   </div>
                      //                   <div className="detail-item highlight">
                      //                     <span className="detail-icon">💰</span>
                      //                     <div className="text-start">
                      //                       <small>Construction Cost</small>
                      //                       <strong>₹ {formatRoundoffCrores(contractor?.cost) || '-'}</strong>
                      //                     </div>
                      //                   </div>

                      //                   {/* EOT Revised Dates */}
                      //                   {contractor.eots?.filter(c => c.eot_status === 'Approved').length > 0 && (() => {
                      //                     const { revisedConstDate, revisedCompDate } = calcFinalEOTDates(contractor);
                      //                     return (
                      //                       <>
                      //                         <div className="detail-item highlight">
                      //                           <span className="detail-icon">⏰</span>
                      //                           <div className="text-start">
                      //                             <small>Revised Const. Completion Date</small>
                      //                             <strong>{revisedConstDate}</strong>
                      //                           </div>
                      //                         </div>
                      //                         <div className="detail-item highlight">
                      //                           <span className="detail-icon">🏁</span>
                      //                           <div className="text-start">
                      //                             <small>Revised Completion Date</small>
                      //                             <strong>{revisedCompDate}</strong>
                      //                           </div>
                      //                         </div>
                      //                       </>
                      //                     );
                      //                   })()}
                      //                 </div>
                      //               </div>
                      //             )}
                      //           </div>
                      //         </td>

                      //         {/* Billing Cell - Expandable */}
                      //         <td className="cell-billing-premium">
                      //           <div className="expandable-section">
                      //             <div
                      //               className="section-header clickable"
                      //               onClick={() => toggleSection(contractorId, 'billing')}
                      //             >
                      //               <span className="section-title">
                      //                 Billing Details
                      //                 {billSummary.hasSPS || billSummary.hasRA ? (
                      //                   <span className="section-badge">Active</span>
                      //                 ) : null}
                      //               </span>
                      //               <button className="expand-btn">
                      //                 {isSectionExpanded(contractorId, 'billing') ?
                      //                   <ChevronUp size={16} /> : <ChevronDown size={16} />
                      //                 }
                      //               </button>
                      //             </div>
                      //             {isSectionExpanded(contractorId, 'billing') && (
                      //               <div className="section-content">
                      //                 {(billSummary.hasSPS || billSummary.hasRA) ? (
                      //                   <div className="billing-enhanced-container">
                      //                     {/* SPS Section */}
                      //                     {billSummary.hasSPS && (
                      //                       <div className="billing-section sps-section">
                      //                         <div className="billing-section-header">
                      //                           <span className="billing-type-badge sps">CA Billing Tracker</span>
                      //                           <span className="billing-bill-count">{billSummary.sps.billCount} bill(s)</span>
                      //                         </div>
                      //                         <div className="billing-fields-simple">
                      //                           <div className="billing-field-row">
                      //                             <span className="field-label">Work Done Amount:</span>
                      //                             <span className="field-value">{formatRoundoffCrores(billSummary.sps.totalWorkDone)}</span>
                      //                           </div>
                      //                           <div className="billing-field-row">
                      //                             <span className="field-label">Escalation Amount:</span>
                      //                             <span className="field-value">{formatRoundoffCrores(billSummary.sps.totalEscalation)}</span>
                      //                           </div>
                      //                           <div className="billing-field-row">
                      //                             <span className="field-label">LD Amount:</span>
                      //                             <span className="field-value negative">{formatRoundoffCrores(billSummary.sps.totalLDAmount)}</span>
                      //                           </div>
                      //                           <div className="billing-field-row">
                      //                             <span className="field-label">Withheld Amount:</span>
                      //                             <span className="field-value">{formatRoundoffCrores(billSummary.sps.withheldAmount)}</span>
                      //                           </div>
                      //                           <div className="billing-field-row total-row">
                      //                             <span className="field-label">Remaining Amount:</span>
                      //                             <span className="field-value highlight">{formatRoundoffCrores(billSummary.sps.remainingAmount)}</span>
                      //                           </div>
                      //                         </div>
                      //                       </div>
                      //                     )}

                      //                     {/* RA Section */}
                      //                     {billSummary.hasRA && (
                      //                       <div className="billing-section ra-section">
                      //                         <div className="billing-section-header">
                      //                           <span className="billing-type-badge ra">RA Bills (by COS)</span>
                      //                         </div>
                      //                         {billSummary.ra.map((cosBill, idx) => (
                      //                           <div key={cosBill.cosId} className="cos-billing-card">
                      //                             <div className="cos-billing-header">
                      //                               <div className="cos-info">
                      //                                 <span className="cos-billing-code">{cosBill.cosCode}</span>
                      //                                 <span className={`cos-status-badge ${cosBill.cosStatus}`}>
                      //                                   {cosBill.cosStatus}
                      //                                 </span>
                      //                               </div>
                      //                               <span className="cos-billing-count">{cosBill.billCount} RA bill(s)</span>
                      //                             </div>
                      //                             <div className="billing-fields-simple">
                      //                               <div className="billing-field-row">
                      //                                 <span className="field-label">Work Done Amount:</span>
                      //                                 <span className="field-value">{formatRoundoffCrores(cosBill.totalWorkDone)}</span>
                      //                               </div>
                      //                               <div className="billing-field-row">
                      //                                 <span className="field-label">Escalation Amount:</span>
                      //                                 <span className="field-value">{formatRoundoffCrores(cosBill.totalEscalation)}</span>
                      //                               </div>
                      //                               <div className="billing-field-row">
                      //                                 <span className="field-label">LD Amount:</span>
                      //                                 <span className="field-value negative">{formatRoundoffCrores(cosBill.totalLDAmount)}</span>
                      //                               </div>
                      //                               <div className="billing-field-row">
                      //                                 <span className="field-label">Withheld Amount:</span>
                      //                                 <span className="field-value">{formatRoundoffCrores(cosBill.withheldAmount)}</span>
                      //                               </div>
                      //                               <div className="billing-field-row total-row">
                      //                                 <span className="field-label">Remaining Amount:</span>
                      //                                 <span className={`field-value ${cosBill.remainingAmount < 0 ? 'negative' : 'highlight'}`}>
                      //                                   {formatRoundoffCrores(cosBill.remainingAmount)}
                      //                                 </span>
                      //                               </div>
                      //                               {cosBill.isFullyUtilized && (
                      //                                 <div className="utilization-warning">
                      //                                   ⚠️ COS fully utilized or exceeded
                      //                                 </div>
                      //                               )}
                      //                             </div>
                      //                           </div>
                      //                         ))}
                      //                       </div>
                      //                     )}
                      //                   </div>
                      //                 ) : (
                      //                   <div className="empty-state-premium">No Billing Details</div>
                      //                 )}
                      //               </div>
                      //             )}
                      //           </div>
                      //         </td>

                      //         {/* COS Cell - Expandable */}
                      //         <td className="cell-cos-premium">
                      //           <div className="expandable-section">
                      //             <div
                      //               className="section-header clickable"
                      //               onClick={() => toggleSection(contractorId, 'cos')}
                      //             >
                      //               <span className="section-title">
                      //                 COS Details ({contractor.coss?.filter(c => c.cos_status === "Approved" || c.cos_status === "inprinciple").length || 0})
                      //               </span>
                      //               <button className="expand-btn">
                      //                 {isSectionExpanded(contractorId, 'cos') ?
                      //                   <ChevronUp size={16} /> : <ChevronDown size={16} />
                      //                 }
                      //               </button>
                      //             </div>
                      //             {isSectionExpanded(contractorId, 'cos') && (
                      //               <div className="section-content">
                      //                 {contractor.coss?.filter(c => c.cos_status === "Approved" || c.cos_status === "inprinciple").length > 0 ? (
                      //                   (() => {
                      //                     const {
                      //                       baseCost,
                      //                       approvedCOS,
                      //                       inPrincipleCOS,
                      //                       revisedCostAfterWorkOrder,
                      //                     } = calcCOSBreakdown(contractor);

                      //                     return (
                      //                       <div className="cos-breakdown-container">
                      //                         {/* Base Cost */}
                      //                         <div className="cos-base-cost-card">
                      //                           <div className="cos-base-left">
                      //                             <span className="cos-base-icon">💼</span>
                      //                             <span className="cos-base-label">Base Cost</span>
                      //                           </div>
                      //                           <span className="cos-base-value">₹ {formatRoundoffCrores(baseCost)}</span>
                      //                         </div>

                      //                         {/* Work Order COS */}
                      //                         {approvedCOS.length > 0 && (
                      //                           <div className="cos-section">
                      //                             <div className="cos-section-header workorder">
                      //                               <span className="cos-section-icon">📋</span>
                      //                               <span>Work Order COS</span>
                      //                               <span className="cos-count-badge wo">{approvedCOS.length}</span>
                      //                             </div>
                      //                             {approvedCOS.map(cos => (
                      //                               <div key={cos.id} className="cos-item-card">
                      //                                 <div className="cos-card-header">
                      //                                   <div className="cos-code-wrap">
                      //                                     <span className="cos-dot wo"></span>
                      //                                     <strong className="cos-code-text">{cos.cos_code}</strong>
                      //                                   </div>
                      //                                   <span className={`cos-type-pill ${cos.cos_type === "negativecos" ? "neg" : "pos"}`}>
                      //                                     {cos.cos_type === "negativecos" ? "▼ Neg" : "▲ Pos"}
                      //                                   </span>
                      //                                 </div>
                      //                                 <div className="cos-amounts-grid">
                      //                                   <div className="cos-amt-cell">
                      //                                     <span className="cos-amt-label">Initiated</span>
                      //                                     <span className="cos-amt-value neutral">
                      //                                       ₹{formatRoundoffCrores(Number(
                      //                                         cos.cos_type === "negativecos"
                      //                                           ? (cos.negativeamount || 0)
                      //                                           : (cos.amount || 0)
                      //                                       ))}
                      //                                     </span>
                      //                                   </div>
                      //                                   <div className="cos-amt-cell">
                      //                                     <span className="cos-amt-label">AE Approved</span>
                      //                                     <span className="cos-amt-value ae">
                      //                                       ₹{formatRoundoffCrores(Number(cos.ae_approved_amount || 0))}
                      //                                     </span>
                      //                                   </div>
                      //                                   <div className={`cos-amt-cell final ${cos.cos_type === "negativecos" ? "neg-bg" : "pos-bg"}`}>
                      //                                     <span className="cos-amt-label">Approved</span>
                      //                                     <span className={`cos-amt-value ${cos.cos_type === "negativecos" ? "negative" : "positive"}`}>
                      //                                       {cos.cos_type === "negativecos" ? "−" : "+"}₹{formatRoundoffCrores(Number(cos.approved_amount || 0))}
                      //                                     </span>
                      //                                   </div>
                      //                                 </div>
                      //                               </div>
                      //                             ))}
                      //                             <div className="cos-revised-total wo">
                      //                               <div className="cos-revised-left">
                      //                                 <span>🏁</span>
                      //                                 <span>Revised Cost after W.O</span>
                      //                               </div>
                      //                               <span className="cos-revised-amount wo">₹ {formatRoundoffCrores(revisedCostAfterWorkOrder)}</span>
                      //                             </div>
                      //                           </div>
                      //                         )}

                      //                         {/* In Principle COS */}
                      //                         {inPrincipleCOS.length > 0 && (
                      //                           <div className="cos-section">
                      //                             <div className="cos-section-header inprinciple">
                      //                               <span className="cos-section-icon">🔖</span>
                      //                               <span>In Principle COS</span>
                      //                               <span className="cos-count-badge ip">{inPrincipleCOS.length}</span>
                      //                             </div>
                      //                             {inPrincipleCOS.map(cos => (
                      //                               <div key={cos.id} className="cos-item-card">
                      //                                 <div className="cos-card-header">
                      //                                   <div className="cos-code-wrap">
                      //                                     <span className="cos-dot ip"></span>
                      //                                     <strong className="cos-code-text">{cos.cos_code}</strong>
                      //                                   </div>
                      //                                   <span className={`cos-type-pill ${cos.cos_type === "negativecos" ? "neg" : "pos"}`}>
                      //                                     {cos.cos_type === "negativecos" ? "▼ Neg" : "▲ Pos"}
                      //                                   </span>
                      //                                 </div>
                      //                                 <div className="cos-amounts-grid">
                      //                                   <div className="cos-amt-cell">
                      //                                     <span className="cos-amt-label">Initiated</span>
                      //                                     <span className="cos-amt-value neutral">
                      //                                       ₹{formatRoundoffCrores(Number(
                      //                                         cos.cos_type === "negativecos"
                      //                                           ? (cos.negativeamount || 0)
                      //                                           : (cos.amount || 0)
                      //                                       ))}
                      //                                     </span>
                      //                                   </div>
                      //                                   <div className="cos-amt-cell">
                      //                                     <span className="cos-amt-label">AE Approved</span>
                      //                                     <span className="cos-amt-value ae">
                      //                                       ₹{formatRoundoffCrores(Number(cos.ae_approved_amount || 0))}
                      //                                     </span>
                      //                                   </div>
                      //                                   <div className={`cos-amt-cell final ${cos.cos_type === "negativecos" ? "neg-bg" : "pos-bg"}`}>
                      //                                     <span className="cos-amt-label">In Principle</span>
                      //                                     <span className={`cos-amt-value ${cos.cos_type === "negativecos" ? "negative" : "positive"}`}>
                      //                                       {cos.cos_type === "negativecos" ? "−" : "+"}₹{formatRoundoffCrores(Number(cos.in_principle_amount_byclient || 0))}
                      //                                     </span>
                      //                                   </div>
                      //                                 </div>
                      //                               </div>
                      //                             ))}
                      //                           </div>
                      //                         )}
                      //                       </div>
                      //                     );
                      //                   })()
                      //                 ) : (
                      //                   <div className="empty-state-premium">No COS</div>
                      //                 )}
                      //               </div>
                      //             )}
                      //           </div>
                      //         </td>

                      //         {/* EOT Cell - Expandable */}
                      //         <td className="cell-eot-premium">
                      //           <div className="expandable-section">
                      //             <div
                      //               className="section-header clickable"
                      //               onClick={() => toggleSection(contractorId, 'eot')}
                      //             >
                      //               <span className="section-title">
                      //                 EOT Details ({contractor.eots?.filter(eot => eot.eot_status === "Approved")?.length || 0})
                      //               </span>
                      //               <button className="expand-btn">
                      //                 {isSectionExpanded(contractorId, 'eot') ?
                      //                   <ChevronUp size={16} /> : <ChevronDown size={16} />
                      //                 }
                      //               </button>
                      //             </div>
                      //             {isSectionExpanded(contractorId, 'eot') && (
                      //               <div className="section-content">
                      //                 {contractor.eots?.filter(eot => eot.eot_status === "Approved")?.length > 0 ? (
                      //                   <div className="eot-timeline">
                      //                     {(() => {
                      //                       const breakdown = calcEOTDateBreakdown(contractor);
                      //                       return contractor.eots
                      //                         .filter(eot => eot.eot_status === "Approved")
                      //                         .sort((a, b) => new Date(a.process_initiate_date) - new Date(b.process_initiate_date))
                      //                         .map((eot) => {
                      //                           const bdItem = breakdown.find(b => b.eot_code === eot.eot_code);
                      //                           return (
                      //                             <div key={eot.eot_code} className="eot-card-new">
                      //                               <div className="eot-card-header">
                      //                                 <strong className="eot-code-label">{eot.eot_code}</strong>
                      //                                 <span className="eot-status-badge approved">
                      //                                   {eot.eot_status}
                      //                                 </span>
                      //                               </div>
                      //                               <div className="eot-days-grid">
                      //                                 <div className="eot-day-item">
                      //                                   <span className="eot-day-label">Requested</span>
                      //                                   <span className="eot-day-value requested">{eot.days ?? '-'} d</span>
                      //                                 </div>
                      //                                 <div className="eot-day-item">
                      //                                   <span className="eot-day-label">AE Approved</span>
                      //                                   <span className="eot-day-value ae">{eot.ae_approved_days ?? '-'} d</span>
                      //                                 </div>
                      //                                 <div className="eot-day-item">
                      //                                   <span className="eot-day-label">Approved</span>
                      //                                   <span className="eot-day-value approved">{eot.approved_days ?? '-'} d</span>
                      //                                 </div>
                      //                               </div>
                      //                               {bdItem && (
                      //                                 <div className="eot-revised-dates">
                      //                                   <div className="eot-date-row">
                      //                                     <span className="eot-date-label">📅 Rev. Const. Date</span>
                      //                                     <span className="eot-date-value">{bdItem.revised_const_completion_date}</span>
                      //                                   </div>
                      //                                   <div className="eot-date-row">
                      //                                     <span className="eot-date-label">🏁 Rev. Completion</span>
                      //                                     <span className="eot-date-value highlight">{bdItem.revised_completion_date}</span>
                      //                                   </div>
                      //                                 </div>
                      //                               )}
                      //                             </div>
                      //                           );
                      //                         });
                      //                     })()}
                      //                   </div>
                      //                 ) : (
                      //                   <div className="empty-state-premium">No EOT</div>
                      //                 )}
                      //               </div>
                      //             )}
                      //           </div>
                      //         </td>

                      //         {/* Letters Cell */}
                      //         <td className="cell-letters-premium">
                      //           <LetterButton contractor={contractor} project={project} />
                      //         </td>

                      //         {/* Actions Column */}
                      //         {contractorIndex === 0 && (
                      //           <td className="cell-actions-premium" rowSpan={contractorCount}>
                      //             <div className="action-group">
                      //               <button
                      //                 onClick={() => ViewAllProjectDetails(project)}
                      //                 className="action-icon view"
                      //                 title="View Details"
                      //               >
                      //                 <Eye size={18} />
                      //                 <span className="action-tooltip">View Details</span>
                      //               </button>
                      //               {role === "Admin" && (
                      //                 <>
                      //                   <div className="action-divider"></div>
                      //                   <Lock
                      //                     apiName="project"
                      //                     id={project.id}
                      //                     i={project}
                      //                     usedFor="Project"
                      //                     getData={getData}
                      //                   />
                      //                   {project.lock === false && (
                      //                     <DeleteProject
                      //                       i={project}
                      //                       fetchContractorProjects={getData}
                      //                     />
                      //                   )}
                      //                 </>
                      //               )}
                      //             </div>
                      //           </td>
                      //         )}
                      //       </tr>
                      //     </Fragment>
                      //   );
                      // })

                      project?.contractors?.map((contractor, contractorIndex) => {
                        const contractorId = contractor.id || `${project.id}-${contractorIndex}`;
                        const detailsKey = `${project.id}-${contractorIndex}`;

                        // Get bill summary for this contractor
                        const billSummary = getBillSummary(contractor, project.contract_mode);

                        // Calculate milestone summary
                        const getMilestoneSummary = (milestones, contractorData) => {
                          if (!milestones?.length) return { achieved: 0, grace: 0, skipped: 0, upcoming: 0, total: 0 };
                          const achieve = milestones.filter(ms => getMilestoneStatus(ms, contractorData.commencement_date, contractorData.grace_period) === 'achieved').length;
                          const grace = milestones.filter(ms => getMilestoneStatus(ms, contractorData.commencement_date, contractorData.grace_period) === 'grace').length;
                          const achieved = Number(achieve) + Number(grace);
                          const skipped = milestones.filter(ms => getMilestoneStatus(ms, contractorData.commencement_date, contractorData.grace_period) === 'skipped').length;
                          const upcoming = milestones.filter(ms => getMilestoneStatus(ms, contractorData.commencement_date, contractorData.grace_period) === 'upcoming').length;
                          return { achieved, grace, skipped, upcoming, total: milestones.length };
                        };



                        // Calculate COS summary
                        const getCOSSummary = (coss) => {
                          const approved = coss?.filter(c => c.cos_status === "Approved") || [];
                          const inPrinciple = coss?.filter(c => c.cos_status === "inprinciple") || [];
                          const totalAmount = approved.reduce((sum, c) => sum + Number(c.approved_amount || 0), 0) +
                            inPrinciple.reduce((sum, c) => sum + Number(c.in_principle_amount_byclient || 0), 0);
                          return { total: (approved.length + inPrinciple.length), totalAmount };
                        };

                        // Calculate EOT summary
                        const getEOTSummary = (eots) => {
                          const approved = eots?.filter(eot => eot.eot_status === "Approved") || [];
                          const totalDays = approved.reduce((sum, eot) => sum + Number(eot.approved_days || 0), 0);
                          return { total: approved.length, totalDays };
                        };

                        const milestoneSummary = getMilestoneSummary(contractor.milestone_details, contractor);
                        const cosSummary = getCOSSummary(contractor.coss);
                        const eotSummary = getEOTSummary(contractor.eots);

                        return (
                          <Fragment key={contractorId}>
                            {/* Main Row */}
                            <tr className="premium-table-row">
                              {contractorIndex === 0 && (
                                <>
                                  <td className="table-body cell-index" rowSpan={contractorCount}>
                                    <div className="index-container">
                                      <span className="index-number">{index + 1}</span>
                                      {contractorCount > 1 && (
                                        <span className="contractor-badge">{contractorCount}</span>
                                      )}
                                    </div>
                                  </td>
                                  <td className="table-body cell-project" rowSpan={contractorCount}>
                                    <div className="project-info">
                                      <div className="project-header">
                                        <span className="project-code">{project?.site_prcode}</span>
                                      </div>
                                      <div className="project-name" title={project?.project_name}>
                                        {project?.project_short_name}
                                      </div>

                                    </div>
                                  </td>
                                  {(role === "Admin" || role === "DataEntryOperator") &&
                                    <td className="table-body cell-project" rowSpan={contractorCount}>
                                      <div className="project-info" style={{ alignItems: "center" }}>
                                        <ProlongationButton project={project?.id} data={project} />

                                      </div>
                                    </td>
                                  }
                                  <td className="table-body cell-project" style={{ verticalAlign: "middle" }} rowSpan={contractorCount} >
                                    <div className="project-info" style={{ alignItems: "center" }} >
                                      <DocumentModel title="Project Drawings" projectCode={project?.id} project={project?.id} />

                                    </div>
                                  </td>
                                </>
                              )}

                              {/* Progress Cell - Expandable */}
                              <td className="table-body cell-progress">
                                <div className="section-content">
                                  <ProgressBarGraph
                                    contractor={contractor}
                                    contractorName={contractor?.name}
                                  />
                                </div>
                              </td>

                              {/* Milestone Cell - Expandable with Summary */}
                              {/* <td className="table-body cell-milestone-premium">
                                <div className="expandable-section">
                                  <div
                                    className="section-header clickable"
                                    onClick={() => toggleSection(contractorId, 'milestone')}
                                  >
                                    <span className="section-title" style={{ marginBottom: "0px" }}>
                                      🎯 Milestones ({milestoneSummary.total})
                                      {milestoneSummary.total > 0 && (
                                        <span className="summary-stats">
                                          <span className="stats-badge milestone-stats">
                                            <span className="stat-achieved">✓ {milestoneSummary.achieved}</span>
                                            <span className="stat-skipped">✗ {milestoneSummary.skipped}</span>
                                            <span className="stat-upcoming">○ {milestoneSummary.upcoming}</span>
                                          </span>
                                        </span>
                                      )}
                                    </span>
                                    <button className="expand-btn">
                                      {isSectionExpanded(contractorId, 'milestone') ?
                                        <ChevronUp size={16} /> : <ChevronDown size={16} />
                                      }
                                    </button>
                                  </div>
                                  {isSectionExpanded(contractorId, 'milestone') && (
                                    <div className="section-content">
                                      {contractor.milestone_details?.length > 0 ? (
                                        <div className="milestone-stack">
                                          {[...contractor.milestone_details]
                                            .sort((a, b) => Number(a.day) - Number(b.day))
                                            .map((ms, idx) => {
                                              const status = getMilestoneStatus(ms);
                                              const hasReschedule = ms.milestone_as_per_reschedule;
                                              const compareDays = hasReschedule
                                                ? Number(ms.reschedule_gap_days)
                                                : Number(ms.day);
                                              const actualDays = Number(ms.actual_gap_days);
                                              const gapOk = ms.milestone_as_per_actual
                                                ? actualDays <= compareDays
                                                : null;

                                              const progressPercent = ms.milestone_percentage ||
                                                (ms.milestone_as_per_actual ? 100 : status === 'upcoming' ? 0 :
                                                  status === 'achieved' ? 100 : 50);

                                              return (
                                                <div
                                                  key={ms.id}
                                                  className={`ms-card ms-${status}`}
                                                  style={{
                                                    animation: `fadeInUp 0.3s ease-out ${idx * 0.05}s both`
                                                  }}
                                                >
                                                  <div className="ms-card-top">
                                                    <div className={`ms-icon ms-icon-${status}`}>
                                                      {status === "achieved" && <CheckCircle size={14} />}
                                                      {status === "skipped" && <XCircle size={14} />}
                                                      {status === "upcoming" && <Clock size={14} />}
                                                    </div>
                                                    <span className="ms-name" title={ms.milestone_name}>
                                                      {ms.milestone_name?.length > 22
                                                        ? ms.milestone_name.slice(0, 22) + "…"
                                                        : ms.milestone_name}
                                                    </span>
                                                    <span className={`ms-badge ms-badge-${status}`}>
                                                      {status === "achieved"
                                                        ? "✓ Achieved"
                                                        : status === "skipped"
                                                          ? "✗ Skipped"
                                                          : "○ To be achieved"}
                                                    </span>
                                                  </div>

                                                  <div className="ms-body">
                                                    <div className="ms-row">
                                                      <Calendar size={11} />
                                                      <span>
                                                        Milestone Date :&nbsp;
                                                        <strong>{formatDate(ms.milestone_date)}</strong>
                                                      </span>
                                                    </div>

                                                    {hasReschedule && (
                                                      <div className="ms-row">
                                                        <RefreshCw size={11} />
                                                        <span>
                                                          Rescheduled Milestone Date:&nbsp;
                                                          <strong>{formatDate(ms.milestone_as_per_reschedule)}</strong>
                                                        </span>
                                                      </div>
                                                    )}

                                                    {ms.milestone_as_per_actual ? (
                                                      <>
                                                        <div className="ms-divider" />
                                                        <div className="ms-row">
                                                          <CalendarCheck size={11} />
                                                          <span>
                                                            Actual:&nbsp;
                                                            <strong>{formatDate(ms.milestone_as_per_actual)}</strong>
                                                          </span>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      <div className="ms-row muted">
                                                        <span>⏳ No actual date recorded</span>
                                                      </div>
                                                    )}
                                                  </div>

                                                  <div className="ms-footer">
                                                    <span className="ms-chip">
                                                      📍 Day {ms.day}
                                                    </span>
                                                    {ms.milestone_percentage && (
                                                      <span className="ms-chip">
                                                        📊 {ms.milestone_percentage}%
                                                      </span>
                                                    )}
                                                    {ms.actual_gap_days && gapOk !== null && (
                                                      <span className={`ms-chip ${gapOk ? "ms-chip-ok" : "ms-chip-warn"}`}>
                                                        {gapOk ? "✅" : "⚠️"} Gap: {ms.actual_gap_days}d
                                                        <span style={{ fontSize: '9px', marginLeft: '2px' }}>
                                                          ({gapOk ? "≤" : ">"} {compareDays}d)
                                                        </span>
                                                      </span>
                                                    )}
                                                  </div>

                                                  <div style={{
                                                    height: '2px',
                                                    background: '#e2e8f0',
                                                    width: '100%',
                                                    position: 'relative'
                                                  }}>
                                                    <div style={{
                                                      position: 'absolute',
                                                      top: 0,
                                                      left: 0,
                                                      height: '100%',
                                                      width: `${progressPercent}%`,
                                                      background: status === 'achieved' ? '#10b981' :
                                                        status === 'skipped' ? '#ef4444' : '#3b82f6',
                                                      transition: 'width 0.4s ease'
                                                    }} />
                                                  </div>
                                                </div>
                                              );
                                            })}
                                        </div>
                                      ) : (
                                        <div className="empty-state-premium">
                                          <span style={{ fontSize: '24px', display: 'block', marginBottom: '8px' }}>📋</span>
                                          No Milestones Assigned
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </td> */}
                              <td className="table-body cell-milestone-premium">
                                <div className="expandable-section">
                                  <div
                                    className="section-header clickable"
                                    onClick={() => toggleSection(contractorId, 'milestone')}
                                  >
                                    <span className="section-title" style={{ marginBottom: "0px" }}>
                                      🎯 Milestones ({milestoneSummary.total})
                                      {milestoneSummary.total > 0 && (
                                        <span className="summary-stats">
                                          <span className="stats-badge milestone-stats">
                                            <span className="stat-achieved">✓ {milestoneSummary.achieved}</span>
                                            <span className="stat-skipped">✗ {milestoneSummary.skipped}</span>
                                            <span className="stat-upcoming">○ {milestoneSummary.upcoming}</span>
                                          </span>
                                        </span>
                                      )}
                                    </span>
                                    <button className="expand-btn">
                                      {isSectionExpanded(contractorId, 'milestone') ?
                                        <ChevronUp size={16} /> : <ChevronDown size={16} />
                                      }
                                    </button>
                                  </div>
                                  {isSectionExpanded(contractorId, 'milestone') && (
                                    <div className="section-content">
                                      {contractor.milestone_details?.length > 0 ? (
                                        <div className="milestone-stack">
                                          {[...contractor.milestone_details]
                                            .sort((a, b) => Number(a.day) - Number(b.day))
                                            .map((ms, idx) => {
                                              const status = getMilestoneStatus(ms, contractor.commencement_date, contractor.grace_period);
                                              const hasReschedule = ms.milestone_as_per_reschedule;

                                              const rescheduleVal = hasReschedule ? ms.rescedule_gap_days : null;
                                              const effectiveDeadline = getEffectiveDeadline(
                                                contractor.commencement_date,
                                                ms.day,
                                                rescheduleVal,
                                                contractor.grace_period
                                              );
                                              const gapOk = ms.milestone_as_per_actual && effectiveDeadline
                                                ? new Date(ms.milestone_as_per_actual) <= effectiveDeadline
                                                : null;

                                              const progressPercent = ms.milestone_percentage ||
                                                (ms.milestone_as_per_actual ? 100 : status === 'upcoming' ? 0 :
                                                  status === 'achieved' ? 100 : 50);

                                              return (
                                                <div
                                                  key={ms.id}
                                                  className={`ms-card ms-${status}`}
                                                  style={{
                                                    animation: `fadeInUp 0.3s ease-out ${idx * 0.05}s both`
                                                  }}
                                                >
                                                  <div className="ms-card-top">
                                                    <div className={`ms-icon ms-icon-${status}`}>
                                                      {status === "achieved" && <CheckCircle size={14} />}
                                                      {status === "grace" && <Clock size={14} />}
                                                      {status === "skipped" && <XCircle size={14} />}
                                                      {status === "upcoming" && <Clock size={14} />}
                                                    </div>
                                                    <span className="ms-name" title={ms.milestone_name}>
                                                      {ms.milestone_name?.length > 22
                                                        ? ms.milestone_name.slice(0, 22) + "…"
                                                        : ms.milestone_name}
                                                    </span>
                                                    {ms.milestone_percentage && (
                                                      <span className="ms-chip">
                                                        📊 {ms.milestone_percentage}%
                                                      </span>
                                                    )}
                                                    <span className={`ms-badge ms-badge-${status}`}>
                                                      {status === "achieved" ? "✓ Achieved"
                                                        : status === "grace" ? "✓ Achieved"
                                                          : status === "skipped" ? "✗ Delayed"
                                                            : "○ To be achieved"}
                                                    </span>
                                                  </div>

                                                  <div className="ms-body">
                                                    <div className="ms-row">
                                                      <Calendar size={11} />
                                                      <span>
                                                        Milestone Date :&nbsp;
                                                        <strong>{formatDate(ms.milestone_date)}</strong>
                                                      </span>
                                                    </div>

                                                    {hasReschedule && (
                                                      <div className="ms-row">
                                                        <RefreshCw size={11} />
                                                        <span>
                                                          Rescheduled Milestone Date:&nbsp;
                                                          <strong>{formatDate(ms.milestone_as_per_reschedule)}</strong>
                                                        </span>
                                                      </div>
                                                    )}
                                                    {effectiveDeadline && (
                                                      <div className="ms-row">
                                                        <Clock size={11} />
                                                        <span>
                                                          Deadline:&nbsp;
                                                          <strong>{formatDate(effectiveDeadline)}</strong>
                                                        </span>
                                                      </div>
                                                    )}

                                                    {ms.milestone_as_per_actual ? (
                                                      <>
                                                        <div className="ms-divider" />
                                                        <div className="ms-row">
                                                          <CalendarCheck size={11} />
                                                          <span>
                                                            Actual:&nbsp;
                                                            <strong>{formatDate(ms.milestone_as_per_actual)}</strong>
                                                          </span>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      <div className="ms-row muted">
                                                        <span>⏳ No actual date recorded</span>
                                                      </div>
                                                    )}

                                                    {/* Effective Deadline row */}

                                                  </div>

                                                  <div className="ms-footer">
                                                    <span className="ms-chip">
                                                      📍Target: {(ms.reschedule_gap_days !== null && ms.reschedule_gap_days !== undefined && ms.reschedule_gap_days !== "")
                                                        ? `${ms.reschedule_gap_days}d`
                                                        : `${ms.day}d`}

                                                    </span>


                                                    <span className="ms-chip">
                                                      ⏳ Grace: {contractor.grace_period ? `${contractor.grace_period}d` : "-"}
                                                    </span>


                                                    <span className="ms-chip">
                                                      Achieved: {ms.actual_gap_days ? `${ms.actual_gap_days}d` : "-"}
                                                    </span>

                                                    {ms.milestone_as_per_actual && effectiveDeadline && (
                                                      <span className={`ms-chip ${status === 'achieved' ? 'ms-chip-ok'
                                                        : status === 'grace' ? 'ms-chip-grace'
                                                          : 'ms-chip-warn'
                                                        }`}>
                                                        {status === 'achieved' ? "✅ On Time Achieved"
                                                          : status === 'grace' ? "⚡ In Grace Period"
                                                            : "⚠️ Skipped"}
                                                      </span>
                                                    )}
                                                  </div>

                                                  <div style={{
                                                    height: '2px',
                                                    background: '#e2e8f0',
                                                    width: '100%',
                                                    position: 'relative'
                                                  }}>
                                                    <div style={{
                                                      position: 'absolute',
                                                      top: 0,
                                                      left: 0,
                                                      height: '100%',
                                                      width: `${progressPercent}%`,
                                                      background: status === 'achieved' ? '#10b981' :
                                                        status === 'skipped' ? '#ef4444' : '#3b82f6',
                                                      transition: 'width 0.4s ease'
                                                    }} />
                                                  </div>
                                                </div>
                                              );
                                            })}
                                        </div>
                                      ) : (
                                        <div className="empty-state-premium">
                                          <span style={{ fontSize: '24px', display: 'block', marginBottom: '8px' }}>📋</span>
                                          No Milestones Assigned
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </td>
                              {/* Contractor Details Cell - Expandable */}
                              <td className=" cell-details-premium">
                                <div className="expandable-section">
                                  <div
                                    className="section-header clickable"
                                    onClick={() => toggleSection(contractorId, 'details')}
                                  >
                                    <div className="contractor-name-premium">
                                      <Building2 size={14} />
                                      <span>{contractor?.name || 'Unnamed Contractor'}</span>
                                    </div>
                                    <button className="expand-btn">
                                      {isSectionExpanded(contractorId, 'details') ?
                                        <ChevronUp size={14} /> : <ChevronDown size={14} />
                                      }
                                    </button>
                                  </div>
                                  {isSectionExpanded(contractorId, 'details') && (
                                    <div className="section-content">
                                      <div className="details-expanded">
                                        <div className="detail-item">
                                          <span className="detail-icon">📅</span>
                                          <div className="text-start">
                                            <small>LOA Award Date</small>
                                            <strong>{formatDate(contractor?.loa_award_date) || '-'}</strong>
                                          </div>
                                        </div>
                                        <div className="detail-item">
                                          <span className="detail-icon">📄</span>
                                          <div className="text-start">
                                            <small>Agreement Date</small>
                                            <strong>{formatDate(contractor?.agreement_date) || '-'}</strong>
                                          </div>
                                        </div>
                                        <div className="detail-item">
                                          <span className="detail-icon">📄</span>
                                          <div className="text-start">
                                            <small>Appointed Date</small>
                                            <strong>{formatDate(contractor?.commencement_date) || '-'}</strong>
                                          </div>
                                        </div>
                                        <div className="detail-item">
                                          <span className="detail-icon">⏰</span>
                                          <div className="text-start">
                                            <small>Const. Completion Date</small>
                                            <strong>{formatDate(contractor.actual_construction_completion_date !== null ? contractor.actual_construction_completion_date : contractor?.schedule_construction_completion_date) || '-'}</strong>
                                          </div>
                                        </div>
                                        <div className="detail-item">
                                          <span className="detail-icon">⏰</span>
                                          <div className="text-start">
                                            <small>Completion Date</small>
                                            <strong>{formatDate(contractor?.actual_completion_date !== null ? contractor?.actual_completion_date : contractor?.schedule_completion_date) || '-'}</strong>
                                          </div>
                                        </div>
                                        <div className="detail-item highlight">
                                          <span className="detail-icon">💰</span>
                                          <div className="text-start">
                                            <small>Construction Cost</small>
                                            <strong>₹ {formatRoundoffCrores(contractor?.cost) || '-'}</strong>
                                          </div>
                                        </div>

                                        {/* EOT Revised Dates */}
                                        {contractor.eots?.filter(c => c.eot_status === 'Approved').length > 0 && (() => {
                                          const { revisedConstDate, revisedCompDate } = calcFinalEOTDates(contractor);
                                          return (
                                            <>
                                              <div className="detail-item highlight">
                                                <span className="detail-icon">⏰</span>
                                                <div className="text-start">
                                                  <small>Revised Const. Completion Date</small>
                                                  <strong>{revisedConstDate}</strong>
                                                </div>
                                              </div>
                                              <div className="detail-item highlight">
                                                <span className="detail-icon">🏁</span>
                                                <div className="text-start">
                                                  <small>Revised Completion Date</small>
                                                  <strong>{revisedCompDate}</strong>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        })()}
                                        {contractor.coss?.filter(c => c.cos_status === 'Approved' || c.cos_status === 'inprinciple').length > 0 && (() => {
                                          const { revisedCostAfterWorkOrder, approvedCOS } = calcCOSBreakdown(contractor);
                                          return (
                                            <>
                                              {approvedCOS.length > 0 && (
                                                <div className="detail-item highlight">
                                                  <span className="detail-icon">💰</span>
                                                  <div className="text-start">
                                                    <small>Revised Cost After W.O COS</small>
                                                    <strong>₹ {formatRoundoffCrores(revisedCostAfterWorkOrder) || '-'}</strong>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          );
                                        })()}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </td>

                              {/* Billing Cell - Expandable with Summary */}
                              <td className="table-body cell-billing-premium">
                                <div className="expandable-section">
                                  <div
                                    className="section-header clickable"
                                    onClick={() => toggleSection(contractorId, 'billing')}
                                  >
                                    <span className="section-title" style={{ marginBottom: "0px" }}>
                                      💰 Billing Details  <span className="stats-badge sps-badge"> Cost: {formatRoundoffCrores(contractor.cost) || '-'}</span>
                                      {(billSummary.hasSPS || billSummary.hasRA) && (
                                        <span className="summary-stats">
                                          {billSummary.hasSPS && (
                                            <span className="stats-badge sps-badge">
                                              {['ham', 'bot'].includes(project.contract_mode?.toLowerCase()) ? 'Milestone' : 'CA'}: {formatRoundoffCrores(billSummary.sps.totalWorkDone)}
                                              (Rem: {formatRoundoffCrores(billSummary.sps.remainingAmount)})
                                            </span>
                                          )}
                                          {billSummary.hasRA && (
                                            <span className="stats-badge ra-badge">
                                              RA: {billSummary.ra.reduce((sum, c) => sum + c.billCount, 0)} bills
                                            </span>
                                          )}
                                        </span>
                                      )}
                                    </span>
                                    <button className="expand-btn">
                                      {isSectionExpanded(contractorId, 'billing') ?
                                        <ChevronUp size={16} /> : <ChevronDown size={16} />
                                      }
                                    </button>
                                  </div>
                                  {isSectionExpanded(contractorId, 'billing') && (
                                    <div className="section-content">
                                      {(billSummary.hasSPS || billSummary.hasRA) ? (
                                        <div className="billing-enhanced-container">
                                          {/* SPS Section */}
                                          {billSummary.hasSPS && (
                                            <div className="billing-section sps-section">
                                              <div className="billing-section-header">
                                                <span className="billing-type-badge sps">
                                                  {/* ✅ Yeh change karo */}
                                                  {['ham', 'bot'].includes(project.contract_mode?.toLowerCase())
                                                    ? 'Milestone Billing Tracker'
                                                    : 'CA Billing Tracker'}
                                                </span>
                                                <span className="billing-bill-count">{billSummary.sps.billCount} bill(s)</span>
                                              </div>
                                              <div className="billing-fields-simple">
                                                <div className="billing-field-row">
                                                  <span className="field-label">Work Done Amount:</span>
                                                  <span className="field-value">{formatRoundoffCrores(billSummary.sps.totalWorkDone)}</span>
                                                </div>
                                                <div className="billing-field-row">
                                                  <span className="field-label">Escalation Amount:</span>
                                                  <span className="field-value">{formatRoundoffCrores(billSummary.sps.totalEscalation)}</span>
                                                </div>
                                                <div className="billing-field-row">
                                                  <span className="field-label">LD Amount:</span>
                                                  <span className="field-value negative">{formatRoundoffCrores(billSummary.sps.totalLDAmount)}</span>
                                                </div>
                                                <div className="billing-field-row">
                                                  <span className="field-label">Withheld Amount:</span>
                                                  <span className="field-value">{formatRoundoffCrores(billSummary.sps.withheldAmount)}</span>
                                                </div>
                                                <div className="billing-field-row total-row">
                                                  <span className="field-label">Remaining Amount:</span>
                                                  <span className="field-value highlight">{formatRoundoffCrores(billSummary.sps.remainingAmount)}</span>
                                                </div>
                                              </div>
                                            </div>
                                          )}

                                          {/* RA Section */}
                                          {billSummary.hasRA && (
                                            <div className="billing-section ra-section">
                                              <div className="billing-section-header">
                                                <span className="billing-type-badge ra">COS Billing Tracker</span>
                                              </div>
                                              {billSummary.ra.map((cosBill, idx) => (
                                                <div key={cosBill.cosId} className="cos-billing-card">
                                                  <div className="cos-billing-header">
                                                    <div className="cos-info">
                                                      <span className="cos-billing-code">{cosBill.cosCode}</span>
                                                      <span className={`cos-status-badge ${cosBill.cosStatus}`}>
                                                        {cosBill.cosStatus}
                                                      </span>
                                                    </div>
                                                    <span className="cos-billing-count">{cosBill.billCount} RA bill(s)</span>
                                                  </div>
                                                  <div className="billing-fields-simple">
                                                    <div className="billing-field-row">
                                                      <span className="field-label">Work Done Amount:</span>
                                                      <span className="field-value">{formatRoundoffCrores(cosBill.totalWorkDone)}</span>
                                                    </div>
                                                    <div className="billing-field-row">
                                                      <span className="field-label">Escalation Amount:</span>
                                                      <span className="field-value">{formatRoundoffCrores(cosBill.totalEscalation)}</span>
                                                    </div>
                                                    <div className="billing-field-row">
                                                      <span className="field-label">LD Amount:</span>
                                                      <span className="field-value negative">{formatRoundoffCrores(cosBill.totalLDAmount)}</span>
                                                    </div>
                                                    <div className="billing-field-row">
                                                      <span className="field-label">Withheld Amount:</span>
                                                      <span className="field-value">{formatRoundoffCrores(cosBill.withheldAmount)}</span>
                                                    </div>
                                                    <div className="billing-field-row total-row">
                                                      <span className="field-label">Remaining Amount:</span>
                                                      <span className={`field-value ${cosBill.remainingAmount < 0 ? 'negative' : 'highlight'}`}>
                                                        {formatRoundoffCrores(cosBill.remainingAmount)}
                                                      </span>
                                                    </div>
                                                    {cosBill.isFullyUtilized && (
                                                      <div className="utilization-warning">
                                                        ⚠️ COS fully utilized or exceeded
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                      ) : (
                                        <div className="empty-state-premium">No Billing Details</div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </td>

                              {/* COS Cell - Expandable with Summary */}
                              <td className="table-body cell-cos-premium">
                                <div className="expandable-section">
                                  <div
                                    className="section-header clickable"
                                    onClick={() => toggleSection(contractorId, 'cos')}
                                  >
                                    <span className="section-title" style={{ marginBottom: "0px" }}>
                                      📋 COS Details ({cosSummary.total})
                                      {cosSummary.totalAmount > 0 && (
                                        <span className="summary-stats">
                                          <span className="stats-badge cos-badge">
                                            Total: {formatRoundoffCrores(cosSummary.totalAmount)}
                                          </span>
                                        </span>
                                      )}
                                    </span>
                                    <button className="expand-btn">
                                      {isSectionExpanded(contractorId, 'cos') ?
                                        <ChevronUp size={16} /> : <ChevronDown size={16} />
                                      }
                                    </button>
                                  </div>
                                  {isSectionExpanded(contractorId, 'cos') && (
                                    <div className="section-content">
                                      {contractor.coss?.filter(c => c.cos_status === "Approved" || c.cos_status === "inprinciple").length > 0 ? (
                                        (() => {
                                          const {
                                            baseCost,
                                            approvedCOS,
                                            inPrincipleCOS,
                                            revisedCostAfterWorkOrder,
                                          } = calcCOSBreakdown(contractor);

                                          return (
                                            <div className="cos-breakdown-container">
                                              {/* Base Cost */}
                                              <div className="cos-base-cost-card">
                                                <div className="cos-base-left">
                                                  <span className="cos-base-icon">💼</span>
                                                  <span className="cos-base-label">Base Cost</span>
                                                </div>
                                                <span className="cos-base-value">₹ {formatRoundoffCrores(baseCost)}</span>
                                              </div>

                                              {/* Work Order COS */}
                                              {approvedCOS.length > 0 && (
                                                <div className="cos-section">
                                                  <div className="cos-section-header workorder">
                                                    <span className="cos-section-icon">📋</span>
                                                    <span>Work Order COS</span>
                                                    <span className="cos-count-badge wo">{approvedCOS.length}</span>
                                                  </div>
                                                  {approvedCOS.sort((a, b) => new Date(a.process_initiate_date) - new Date(b.process_initiate_date)).map(cos => (
                                                    <div key={cos.id} className="cos-item-card">
                                                      <div className="cos-card-header">
                                                        <div className="cos-code-wrap">
                                                          <span className="cos-dot wo"></span>
                                                          <strong className="cos-code-text">{cos.cos_code}</strong>
                                                        </div>
                                                        <span className={`cos-type-pill ${cos.cos_type === "negativecos" ? "neg" : "pos"}`}>
                                                          {cos.cos_type === "negativecos" ? "▼ Neg" : "▲ Pos"}
                                                        </span>
                                                      </div>
                                                      <div className="cos-amounts-grid">
                                                        <div className="cos-amt-cell">
                                                          <span className="cos-amt-label">Initiated</span>
                                                          <span className="cos-amt-value neutral">
                                                            ₹{formatRoundoffCrores(Number(
                                                              cos.cos_type === "negativecos"
                                                                ? (cos.negativeamount || 0)
                                                                : (cos.amount || 0)
                                                            ))}
                                                          </span>
                                                        </div>
                                                        <div className="cos-amt-cell" style={{ width: "7vw" }}>
                                                          <span className="cos-amt-label">AE/IE Recommended</span>
                                                          <span className="cos-amt-value ae">
                                                            ₹{formatRoundoffCrores(Number(cos.ae_approved_amount || 0))}
                                                          </span>
                                                        </div>
                                                        <div style={{ width: "5vw" }} className={`cos-amt-cell final ${cos.cos_type === "negativecos" ? "neg-bg" : "pos-bg"}`}>
                                                          <span className="cos-amt-label">Client Approved</span>
                                                          <span className={`cos-amt-value ${cos.cos_type === "negativecos" ? "negative" : "positive"}`}>
                                                            {cos.cos_type === "negativecos" ? "−" : "+"}₹{formatRoundoffCrores(Number(cos.approved_amount || 0))}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ))}
                                                  <div className="cos-revised-total wo">
                                                    <div className="cos-revised-left">
                                                      <span>🏁</span>
                                                      <span>Revised Cost after W.O</span>
                                                    </div>
                                                    <span className="cos-revised-amount wo">₹ {formatRoundoffCrores(revisedCostAfterWorkOrder)}</span>
                                                  </div>
                                                </div>
                                              )}

                                              {/* In Principle COS */}
                                              {inPrincipleCOS.length > 0 && (
                                                <div className="cos-section">
                                                  <div className="cos-section-header inprinciple">
                                                    <span className="cos-section-icon">🔖</span>
                                                    <span>In Principle COS</span>
                                                    <span className="cos-count-badge ip">{inPrincipleCOS.length}</span>
                                                  </div>
                                                  {inPrincipleCOS.map(cos => (
                                                    <div key={cos.id} className="cos-item-card">
                                                      <div className="cos-card-header">
                                                        <div className="cos-code-wrap">
                                                          <span className="cos-dot ip"></span>
                                                          <strong className="cos-code-text">{cos.cos_code}</strong>
                                                        </div>
                                                        <span className={`cos-type-pill ${cos.cos_type === "negativecos" ? "neg" : "pos"}`}>
                                                          {cos.cos_type === "negativecos" ? "▼ Neg" : "▲ Pos"}
                                                        </span>
                                                      </div>
                                                      <div className="cos-amounts-grid">
                                                        <div className="cos-amt-cell">
                                                          <span className="cos-amt-label">Initiated</span>
                                                          <span className="cos-amt-value neutral">
                                                            ₹{formatRoundoffCrores(Number(
                                                              cos.cos_type === "negativecos"
                                                                ? (cos.negativeamount || 0)
                                                                : (cos.amount || 0)
                                                            ))}
                                                          </span>
                                                        </div>
                                                        <div className="cos-amt-cell">
                                                          <span className="cos-amt-label">AE Approved</span>
                                                          <span className="cos-amt-value ae">
                                                            ₹{formatRoundoffCrores(Number(cos.ae_approved_amount || 0))}
                                                          </span>
                                                        </div>
                                                        <div className={`cos-amt-cell final ${cos.cos_type === "negativecos" ? "neg-bg" : "pos-bg"}`}>
                                                          <span className="cos-amt-label">In Principle</span>
                                                          <span className={`cos-amt-value ${cos.cos_type === "negativecos" ? "negative" : "positive"}`}>
                                                            {cos.cos_type === "negativecos" ? "−" : "+"}₹{formatRoundoffCrores(Number(cos.in_principle_amount_byclient || 0))}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ))}
                                                </div>
                                              )}
                                            </div>
                                          );
                                        })()
                                      ) : (
                                        <div className="empty-state-premium">No COS</div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </td>

                              {/* EOT Cell - Expandable with Summary */}
                              <td className="table-body cell-eot-premium">
                                <div className="expandable-section">
                                  <div
                                    className="section-header clickable"
                                    onClick={() => toggleSection(contractorId, 'eot')}
                                  >
                                    <span className="section-title" style={{ marginBottom: "0px" }}>
                                      ⏰ EOT Details ({eotSummary.total})
                                      {eotSummary.totalDays > 0 && (
                                        <span className="summary-stats">
                                          <span className="stats-badge eot-badge">
                                            Total: {eotSummary.totalDays} days
                                          </span>
                                        </span>
                                      )}
                                    </span>
                                    <button className="expand-btn">
                                      {isSectionExpanded(contractorId, 'eot') ?
                                        <ChevronUp size={16} /> : <ChevronDown size={16} />
                                      }
                                    </button>
                                  </div>
                                  {isSectionExpanded(contractorId, 'eot') && (
                                    <div className="section-content">
                                      {contractor.eots?.filter(eot => eot.eot_status === "Approved")?.length > 0 ? (
                                        <div className="eot-timeline">
                                          {(() => {
                                            const breakdown = calcEOTDateBreakdown(contractor);
                                            return contractor.eots
                                              .filter(eot => eot.eot_status === "Approved")
                                              .sort((a, b) => new Date(a.process_initiate_date) - new Date(b.process_initiate_date))
                                              .map((eot) => {
                                                const bdItem = breakdown.find(b => b.eot_code === eot.eot_code);
                                                return (
                                                  <div key={eot.eot_code} className="eot-card-new">
                                                    <div className="eot-card-header">
                                                      <strong className="eot-code-label">{eot.eot_code}</strong>
                                                      <span className="eot-status-badge approved">
                                                        {eot.eot_status}
                                                      </span>
                                                    </div>
                                                    <div className="eot-days-grid">
                                                      <div className="eot-day-item" >
                                                        <span className="eot-day-label">Requested</span>
                                                        <span className="eot-day-value requested">{eot.days ?? '-'} d</span>
                                                      </div>
                                                      <div className="eot-day-item" style={{ width: "7vw" }}>
                                                        <span className="eot-day-label">AE/IE Recommended</span>
                                                        <span className="eot-day-value ae">{eot.ae_approved_days ?? '-'} d</span>
                                                      </div>
                                                      <div className="eot-day-item" style={{ width: "5vw" }}>
                                                        <span className="eot-day-label">Client Approved</span>
                                                        <span className="eot-day-value approved">{eot.approved_days ?? '-'} d</span>
                                                      </div>
                                                    </div>
                                                    {bdItem && (
                                                      <div className="eot-revised-dates">
                                                        <div className="eot-date-row">
                                                          <span className="eot-date-label">📅 Rev. Const. Date</span>
                                                          <span className="eot-date-value">{bdItem.revised_const_completion_date}</span>
                                                        </div>
                                                        <div className="eot-date-row">
                                                          <span className="eot-date-label">🏁 Rev. Completion</span>
                                                          <span className="eot-date-value highlight">{bdItem.revised_completion_date}</span>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              });
                                          })()}
                                        </div>
                                      ) : (
                                        <div className="empty-state-premium">No EOT</div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </td>

                              {/* Letters Cell */}
                              <td className="table-body cell-letters-premium">
                                <LetterButton contractor={contractor} project={project} />
                              </td>

                              {/* Actions Column */}
                              {contractorIndex === 0 && (
                                <td className=" cell-actions-premium" rowSpan={contractorCount}>
                                  <div className="action-group">
                                    <button
                                      onClick={() => ViewAllProjectDetails(project)}
                                      className="action-icon view"
                                      title="View Details"
                                    >
                                      <Eye size={18} />
                                      <span className="action-tooltip">View Details</span>
                                    </button>
                                    {role === "Admin" && (
                                      <>
                                        <div className="action-divider"></div>
                                        <Lock
                                          apiName="project"
                                          id={project.id}
                                          i={project}
                                          usedFor="Project"
                                          getData={getData}
                                        />
                                        {project.lock === false && (
                                          <DeleteProject
                                            i={project}
                                            fetchContractorProjects={getData}
                                          />
                                        )}
                                      </>
                                    )}
                                  </div>
                                </td>
                              )}
                            </tr>
                          </Fragment>
                        );
                      })
                    ) : (
                      <tr className="premium-table-row empty">
                        <td className="cell-index">
                          <span className="index-number">{index + 1}</span>
                        </td>
                        <td className="cell-project">
                          <div className="project-info">
                            <span className="project-code">{project?.site_prcode}</span>
                            <div className="project-name">{project?.project_short_name}</div>
                          </div>
                        </td>
                        {(role === "Admin" || role === "DataEntryOperator") &&

                          <td className="cell-project">
                            <div className="project-info">
                              <div className="project-info" style={{ alignItems: "center" }}>
                                <ProlongationButton project={project?.id} />

                              </div>
                            </div>
                          </td>
                        }
                        <td className="cell-project">
                          <div className="project-info">
                            <div className="project-info" style={{ alignItems: "center" }}>
                              <DocumentModel title="Project Drawings" projectCode={project?.site_prcode} project={project?.id} />


                            </div>
                          </div>
                        </td>

                        <td colSpan={role === "Hr" ? 5 : role === "Admin" || role === "DataEntryOperator" ? 7 : 6} className="empty-state-cell">
                          <div className="empty-state-premium interactive">
                            <div className="empty-icon">🏗️</div>
                            <h4>No Contractors Added</h4>
                            <p>This project doesn't have any contractors yet.</p>

                            <AddContractor
                              projectId={project.id}
                              getProjects={getData}
                              getProjectContractorDetails={getData}
                              getDetails={getData}
                            />
                          </div>
                        </td>
                        <td className="cell-actions-premium">
                          <button onClick={() => ViewAllProjectDetails(project)} className="action-icon view">
                            <Eye size={18} />
                          </button>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="cards-view-container">
          {filteredProject.map((project, index) => (
            <ProjectCard
              key={project.id}
              project={project}
              index={index}
              onView={ViewAllProjectDetails}
              role={role}
              getData={getData}
              DeleteProject={DeleteProject}
              Lock={Lock}
            />
          ))}
        </div>
      )}

      {/* CSS styles for the updated billing components */}
      <style jsx>{`
        .billing-enhanced-container {
          display: flex;
          flex-direction: column;
          gap: 12px;
          padding: 8px;
          max-height: 500px;
          overflow-y: auto;
        }
        
        .billing-section {
          background: #f8fafc;
          border-radius: 8px;
          padding: 10px;
          border-left: 3px solid;
        }
        
        .billing-section.sps-section {
          border-left-color: #3b82f6;
        }
        
        .billing-section.ra-section {
          border-left-color: #10b981;
        }
        
        .billing-section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          padding-bottom: 6px;
          border-bottom: 1px solid #e2e8f0;
        }
        
        .billing-type-badge {
          font-size: 10px;
          font-weight: 600;
          padding: 2px 8px;
          border-radius: 12px;
          text-transform: uppercase;
        }
        
        .billing-type-badge.sps {
          background: #dbeafe;
          color: #1e40af;
        }
        
        .billing-type-badge.ra {
          background: #d1fae5;
          color: #065f46;
        }
        
        .billing-bill-count {
          font-size: 10px;
          color: #64748b;
        }
        
        .billing-main-calculation {
          background: white;
          border-radius: 6px;
          padding: 8px;
          margin-bottom: 8px;
        }
        
        .calculation-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 4px 0;
          font-size: 11px;
        }
        
        .calculation-row.subtract {
          color: #ef4444;
        }
        
        .calculation-row.total {
          font-weight: bold;
          font-size: 12px;
          margin-top: 4px;
        }
        
        .calculation-row.total.warning {
          background: #fef3c7;
          border-radius: 4px;
          padding: 6px;
        }
        
        .calculation-divider {
          height: 1px;
          background: #e2e8f0;
          margin: 4px 0;
        }
        
        .calc-label {
          color: #475569;
        }
        
        .calc-value {
          font-weight: 500;
          color: #0f172a;
        }
        
        .calc-value.highlight {
          color: #0284c7;
          font-weight: bold;
        }
        
        .calc-value.negative {
          color: #ef4444;
        }
        
        .billing-details-dropdown {
          margin-top: 6px;
        }
        
        .billing-details-dropdown summary {
          font-size: 10px;
          color: #3b82f6;
          cursor: pointer;
          padding: 4px;
          user-select: none;
        }
        
        .billing-details-dropdown summary:hover {
          color: #2563eb;
        }
        
        .billing-details-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 6px;
          font-size: 10px;
          padding: 8px;
          background: #f1f5f9;
          border-radius: 6px;
          margin-top: 6px;
        }
        
        .billing-detail-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .billing-detail-item .detail-label {
          color: #64748b;
        }
        
        .billing-detail-item .detail-value {
          font-weight: 500;
          color: #0f172a;
        }
        
        .billing-detail-item .detail-value.negative {
          color: #ef4444;
        }
        
        .billing-detail-item .detail-value.positive {
          color: #10b981;
        }
        
        .billing-detail-item.highlight {
          background: #e0f2fe;
          padding: 4px 6px;
          border-radius: 4px;
          grid-column: span 2;
        }
        
        .cos-billing-card {
          background: white;
          border-radius: 6px;
          padding: 8px;
          margin-bottom: 8px;
          border: 1px solid #e2e8f0;
        }
        
        .cos-billing-card:last-child {
          margin-bottom: 0;
        }
        
        .cos-billing-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          padding-bottom: 6px;
          border-bottom: 1px dashed #cbd5e1;
        }
        
        .cos-info {
          display: flex;
          align-items: center;
          gap: 6px;
        }
        
        .cos-billing-code {
          font-weight: bold;
          font-size: 11px;
          color: #475569;
        }
        
        .cos-status-badge {
          font-size: 9px;
          padding: 2px 6px;
          border-radius: 10px;
        }
        
        .cos-status-badge.Approved {
          background: #d1fae5;
          color: #065f46;
        }
        
        .cos-status-badge.inprinciple {
          background: #fef3c7;
          color: #92400e;
        }
        
        .cos-billing-count {
          font-size: 9px;
          color: #94a3b8;
        }
        
        .cos-main-calculation {
          margin-bottom: 6px;
        }
        
        .utilization-warning {
          font-size: 9px;
          color: #d97706;
          margin-top: 4px;
          padding: 4px;
          background: #fef3c7;
          border-radius: 4px;
          text-align: center;
        }
        
        .ra-bills-list {
          margin-top: 8px;
          padding-top: 6px;
          border-top: 1px solid #e2e8f0;
        }
        
        .ra-bills-title {
          font-size: 9px;
          font-weight: 500;
          color: #64748b;
          margin-bottom: 4px;
        }
        
        .ra-bill-item {
          display: flex;
          justify-content: space-between;
          font-size: 9px;
          padding: 2px 0;
        }
        
        .bill-number {
          color: #475569;
        }
        
        .bill-amount {
          font-weight: 500;
          color: #0f172a;
        }
      `}</style>
    </div>
  );
};


const ProjectConsultantView = ({ subCompany, searchName, searchSort }) => {
  const role = sessionStorage.getItem('sitemanagement_role');


  const [projectsList, setProjectsList] = useState([]);
  const [filteredProject, setFilteredProject] = useState([]);
  const [buffer, setBuffering] = useState(true);
  const navigate = useNavigate();

  // Function to fetch projects for consultants
  const fetchConsultantProjects = async () => {
    setBuffering(true);

    const role = sessionStorage.getItem("sitemanagement_role");
    const empId = sessionStorage.getItem("sitemanagement_emp_id");

    let endpoint = "";

    if (role === "Admin") {
      endpoint = `${BASE_URL}/siteproject/projectdashboard/consultant/${searchName}/${subCompany || "null"}/null/`;
    } else if (role === "AuthorityEngineer") {
      endpoint = `${BASE_URL}/siteproject/projectdashboardauth/consultant/${empId}/${subCompany || "null"}/null/`;
    } else if (role === "DataEntryOperator") {
      endpoint = `${BASE_URL}/siteproject/projectdashboardcomp/consultant/${empId}/null/`;
    } else {
      endpoint = `${BASE_URL}/siteproject/projectdashboard/consultant/${searchName}/${subCompany || "null"}/null/`;
    }


    try {
      const response = await axios.get(endpoint);


      let filteredProjects = response.data;
      switch (searchSort) {
        case "asc_pr":
          filteredProjects = sortProjects(filteredProjects, "site_prcode");
          break;
        case "desc_pr":
          filteredProjects = sortProjects(filteredProjects, "site_prcode").reverse();
          break;
        case "asc_short_name":
          filteredProjects = filteredProjects.sort((a, b) =>
            a.project_short_name.localeCompare(b.project_short_name)
          );
          break;
        case "desc_short_name":
          filteredProjects = filteredProjects.sort((a, b) =>
            b.project_short_name.localeCompare(a.project_short_name)
          );
          break;
        default:
          break;
      }

      // const sortingdata = sortProjects(filteredProjects)

      setProjectsList(filteredProjects);
      setFilteredProject(filteredProjects);

    } catch (error) {
      console.error('Error fetching consultant projects:', error);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    fetchConsultantProjects();
  }, [subCompany, searchSort, searchName]); // Refetch projects when filters change





  const [viewMode, setViewMode] = useState('inactive'); // employees or inactive
  const tableRef = useRef(null);


  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const toggleshow = "Consultant";

  const ViewAllProjectDetails = (project) => {
    navigate(`/${urlParts[3]}/ProjectAllDetails/`, {
      state: { project, toggleshow },
    });
  };

  // Helper function to split an array into two equal parts
  const splitArray = (array) => {
    const midIndex = Math.ceil(array.length / 2);
    return [array.slice(0, midIndex), array.slice(midIndex)];
  };

  const handleViewToggle = (mode) => {
    setViewMode(mode);
  };

  return (
    <>
      <div className="filter-showing">
        <div>Consultant details:</div>
        <div>
          Showing {filteredProject.length} of {projectsList.length}
        </div>
      </div>

      {/* Toggle between Employees and Inactive Designations */}
      <div className="bloc-tabss2  wfm-margin" >
        <button
          className={viewMode === "inactive" ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}

          onClick={() => handleViewToggle('inactive')}
        >
          Vacant Positions
        </button>
        <button
          className={viewMode === "employees" ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
          onClick={() => handleViewToggle('employees')}
        >
          View Employees
        </button>

      </div>

      <div className=" table-css-white-background table-box scroll-container-table" style={{ paddingTop: "0px" }}>
        <table ref={tableRef} className="table-css">
          <thead className="table-heading">
            <tr className="custom-table-head-th">
              <th className="table-heading-text">S.no.</th>
              <th className="table-heading-text">Project</th>
              <th className="table-heading-text text-center">Project Details</th>
              <th className="table-heading-text text-center">Key Professionals</th>
              <th className="table-heading-text text-center">Sub Professionals</th>
              <th className="table-heading-text text-center">Support Staff</th>
              <th className="table-heading-text">View Details</th>
              {role === "Admin" &&
                <th className="table-heading-text">Lock</th>

              }
              {role === "Admin" &&
                <th className="table-heading-text">Delete</th>

              }
            </tr>
          </thead>


          {buffer ? <div className="spinner-bgdatil"></div> : null}
          <tbody>
            {filteredProject?.map((project, index) => (
              <React.Fragment key={index}>
                <tr key={project.id} className="custom-table-head-td">
                  {/* Project Name and Short Description */}
                  <td className="table-body">{index + 1} </td>
                  <td className="table-body" title={`Project Name: \n${project.project_name}`} >
                    {project.site_prcode} : <br /><div style={{ width: "120px", whiteSpace: "normal" }}>{project.project_short_name}</div>
                  </td>

                  {/* Project Details */}
                  <td className="table-body">
                    {project.project_name ? (
                      <div className="employee-card-image">
                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                          <tbody>
                            <tr>
                              <td className="padding-bottom-5px">Consultant LOA</td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">{project?.loa_award_date ? formattedDateLong(project?.loa_award_date) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="padding-bottom-5px">Completion Date</td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">{project?.project_completion_date ? formattedDateLong(project?.project_completion_date) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="padding-bottom-5px">Consultancy Fees</td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">{formatRoundoff(project?.consultancy_fees) || "-"}</td>
                            </tr>
                            <tr>
                              <td className="padding-bottom-5px">Contract Mode</td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">{project?.contract_mode || "-"}</td>
                            </tr>
                            <tr>
                              <td className="padding-bottom-5px">Lead</td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right"> <div style={{ whiteSpace: "normal", paddingBottom: "5px" }}>{project?.lead || "-"}</div></td>
                            </tr>
                            <tr>
                              <td className="padding-bottom-5px">JV</td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right "  ><div style={{ whiteSpace: "normal", paddingBottom: "5px" }}>{project?.JV || "-"}</div></td>
                            </tr>
                            <tr>
                              <td className="padding-bottom-5px">Association</td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right"><div style={{ whiteSpace: "normal", paddingBottom: "5px" }}>{project?.association || "-"}</div></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="table-body ">
                        <p className="text-center">-</p>
                      </div>
                    )}
                  </td>

                  {/* Key Professionals */}
                  <td className="table-body">
                    {viewMode === 'employees' && project.employees?.key_professionals?.length > 0 ? (
                      <div className="employee-card-image">
                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                          <thead>
                            <tr>
                              <th className="padding-bottom-5px">Name</th>
                              <th style={{ padding: "0px 4px" }}>:</th>
                              <th className="padding-bottom-5px">Designation</th>
                            </tr>
                          </thead>
                          <tbody>
                            {project.employees?.key_professionals?.map((keyProfessional) => (
                              <tr key={keyProfessional.id}>
                                <td className="padding-bottom-5px">{keyProfessional.name}</td>
                                <td style={{ padding: "0px 4px" }}>:</td>
                                <td className="padding-bottom-5px">{keyProfessional.designation}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : viewMode === 'inactive' && project.inactive_or_no_employee_designations.key_professionals?.length > 0 ? (
                      <div className="employee-card-image">
                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                          <thead>
                            <tr>
                              <th className="padding-bottom-5px">Designation</th>
                              <th style={{ padding: "0px 4px" }}>:</th>

                              <th className="padding-bottom-5px text-center">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {project.inactive_or_no_employee_designations.key_professionals.map((designation, index) => (
                              <tr key={index}>
                                <td className="padding-bottom-5px">{designation.designation}</td>
                                <td style={{ padding: "0px 4px" }}>:</td>

                                <td className="padding-bottom-5px">{designation.status}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="align-center ">
                        <p className="text-center">-</p>
                      </div>
                    )}
                  </td>

                  {/* Sub Professionals */}
                  <td className="table-body">
                    {viewMode === 'employees' && project.employees.sub_professionals?.length > 0 ? (
                      <div className="employee-card-image">
                        {splitArray(project.employees.sub_professionals).map((split, index) => (

                          <table style={{ borderCollapse: "collapse", width: "100%" }}>
                            <thead>
                              <tr>
                                <th className="padding-bottom-5px">Name</th>
                                <td style={{ padding: "0px 4px" }}>:</td>
                                <th className="padding-bottom-5px">Designation</th>
                              </tr>
                            </thead>
                            <tbody>
                              {split.map((subProfessional) => (
                                <tr key={subProfessional.id}>
                                  <td className="padding-bottom-5px"> {subProfessional.name}</td>
                                  <td style={{ padding: "0px 4px" }}>:</td>

                                  <td className="padding-bottom-5px">{subProfessional.designation}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ))}
                      </div>
                    ) : viewMode === 'inactive' && project.inactive_or_no_employee_designations.sub_professionals?.length > 0 ? (
                      <div className="employee-card-image">
                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                          <thead>
                            <tr>
                              <th className="padding-bottom-5px">Designation</th>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <th className="padding-bottom-5px">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {project.inactive_or_no_employee_designations.sub_professionals.map((designation, index) => (
                              <tr key={index}>
                                <td className="padding-bottom-5px">{designation.designation}</td>
                                <td style={{ padding: "0px 4px" }}>:</td>

                                <td className="padding-bottom-5px">{designation.status}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="align-center ">
                        <p className="text-center">-</p>
                      </div>
                    )}
                  </td>

                  {/* Support Staff */}
                  <td className="table-body">
                    {viewMode === 'employees' && project.employees.support_staff?.length > 0 ? (
                      <div className="employee-card-image">
                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                          <thead>
                            <tr>
                              <th className="padding-bottom-5px">Name</th>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <th className="padding-bottom-5px">Designation</th>
                            </tr>
                          </thead>
                          <tbody>
                            {project.employees.support_staff.map((supportStaff) => (
                              <tr key={supportStaff.id}>
                                <td className="padding-bottom-5px">{supportStaff.name}</td>
                                <td style={{ padding: "0px 4px" }}>:</td>
                                <td className="padding-bottom-5px">{supportStaff.designation}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : viewMode === 'inactive' && project.inactive_or_no_employee_designations.support_staff?.length > 0 ? (
                      <div className="employee-card-image">
                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                          <thead>
                            <tr>
                              <th className="padding-bottom-5px">Designation</th>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <th className="padding-bottom-5px">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {project.inactive_or_no_employee_designations.support_staff.map((designation, index) => (
                              <tr key={index}>
                                <td className="padding-bottom-5px">{designation.designation}</td>
                                <td style={{ padding: "0px 4px" }}>:</td>
                                <td className="padding-bottom-5px">{designation.status}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="align-center ">
                        <p className="text-center">-</p>
                      </div>
                    )}
                  </td>

                  {/* View Details Button */}
                  <td className="table-body text-center">
                    <button onClick={() => ViewAllProjectDetails(project)} title="View Project Details" className="">
                      <Eye />
                    </button>
                  </td>
                  {
                    role === "Admin" &&
                    <td className="table-body text-center">
                      <Lock apiName="project" id={project.id} i={project} usedFor="Project" getData={fetchConsultantProjects} />
                    </td>
                  }



                  <td className="table-body text-center">
                    {role === "Admin" &&
                      <>
                        {project.lock === false &&
                          <DeleteProject i={project} fetchContractorProjects={fetchConsultantProjects} />
                        }
                      </>
                    }
                  </td>

                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );

};




export {

  SiteProjectTable,
  Detailspage
};
